<template>
  <div class="order_component" v-if="accessCommande()">
    <div
      v-show="total_count != 0"
      class="bottom_commande"
      @click="checkScreen"
      data-toggle="modal"
      data-target="#cartModal"
    >
      <div class="bottom_content container">
        <div class="bottom_content_box count_articles">
          <span>Voir ma commande . </span>
          <span>( x{{ total_count }} ) </span>
        </div>
        <div class="bottom_content_box">
          <span>
            {{ total * 1 + pourboir * 1 }}{{ currentCurrency.symbol }}
          </span>
        </div>
      </div>
    </div>

    <modal name="order" @opened="onOpened" @closed="onClosed">
      <div class="modal_content payment_modal full_gray dark_modal">
        <div class="dark_header" @click="$modal.hide('order')">
          <img
            src="htttp://localhost:3333/new_images/orange_left_arrow.png"
            alt=""
            srcset=""
          />
        </div>

        <div class="full full_gray center paymement_buttons_full">
          <div class="split_message">
            <div class="split_message_text">
              <span>Ma</span>
              <span class="orange_circle"></span>
              <span class="orange_circle"></span>
            </div>
            <div class="split_message_text1">
              <span>Commande</span>
              <span class="orange_circle"></span>
              <span class="orange_circle"></span>
            </div>
          </div>

          <div class="payement_buttons_container">
            <div class="payement_buttons"></div>
          </div>
          <div class="payment_content">
            <div class="transfert_block">
              <div class="payment_content_button mb3" @click="closeAllPopups">
                <span>Ajouter de articles a ma commande </span>
                <div class="arrow_right">
                  <span>></span>
                </div>
              </div>
              <!--<div
                class="payment_content_button mb3"
                @click="$modal.show('payment')"
              >-->
              <div class="payment_content_button mb3" @click="fideliteorpay()">
                <span>Payer ma commande </span>
                <div class="arrow_right">
                  <span>></span>
                </div>
              </div>
              <div
                class="payment_content_button mb3"
                @click="$modal.show('cart')"
              >
                <span>Consulter ma commande </span>
                <div class="arrow_right">
                  <span>></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="modal-footer  bottom_commande_cart">
         
          <div id="payemnt_back" @click="$modal.hide('payment')">
            <span class="caret-left"><i class="fas fa-chevron-left"></i></span>
            <div class="button_commander">Retour</div>
          </div>
        </div> -->
      </div>
    </modal>
    <modal name="cart" @opened="onOpened" @closed="onClosed">
      <div class="modal_title cart_header" @click="$modal.hide('cart')">
        <div class="modal_down"></div>
      </div>

      <div class="modal_content full_gray full_gray_panier">
        <div class="full full_gray">
          <div class="panier_header">
            <div class="pnaier_card">
              Commande<span class="orange_circle"></span>
            </div>
            <span class="panier_count"
              ><strong class="orange_text">{{
                selectedTable ? `la table ${selectedTable} / ` : ""
              }}</strong
              >{{ total_count }} articles</span
            >
          </div>
          <div class="panier_items_pay">
            <swipe-list
              class=""
              :items="reserved_items_client"
              transition-key="id"
              @swipeout:contentclick="contentClick"
              @swipeout:click="itemClick"
              @swipeout:doubleclick="itemDblClick"
            >
              <template
                slot-scope="{ item, index, revealLeft, revealRight, close }"
              >
                <div class="fact_item">
                  <div class="fact_item_left">
                    <img
                      :src="`htttp://localhost:3333/uploads/menus-items/${item.image}`"
                      class="fact_item_image"
                      alt=""
                      srcset=""
                      v-if="item.image"
                    />
                    <img
                      src="htttp://localhost:3333/assets/img/notification-thumb-2.jpg"
                      class="fact_item_image"
                      alt=""
                      v-else
                      srcset=""
                    />

                    <div class="fact_item_infos">
                      <span class="fact_item_name">{{ item.name }} </span>
                      <div class="fact_item_controls">
                        <div
                          :class="`minus_controle `"
                          v-if="item.objectNumber"
                          @click="SubstractQuanity(item.index, item)"
                        >
                          <span>-</span>
                        </div>
                        <div :class="`minus_controle disabled`" v-else>
                          <span>-</span>
                        </div>
                        <div class="quantity_controle">
                          <span>{{ item.quantity }}</span>
                        </div>

                        <div
                          class="plus_controle"
                          @click="AddQuanity(item.index)"
                        >
                          <span>+</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <span class="fact_item_price"
                    >{{ (item.unitPrice * item.quantity).toFixed(2) }}
                    {{ currentCurrency.symbol }}
                  </span>
                </div>
              </template>
              <template slot="right" slot-scope="{ item }">
                <!-- left swipe side template and slot-scope="{ item }" is the item clearly -->
                <!-- remove <template slot="left" slot-scope="{ item }"> if you dont wanna have left swipe side  -->
                <div class="swipeout-action action-panel-left">
                  <div @click="RemoveItem(item.index)">
                    <!-- place icon here or what ever you want -->
                    <i class="fa fa-trash"></i>
                  </div>
                </div>
              </template>
            </swipe-list>
            <div
              class="empty_container"
              v-if="reserved_items_client.length == 0"
            >
              <div class="empty">
                <img
                  src="htttp://localhost:3333/illustrations/empty.gif"
                  alt=""
                  srcset=""
                />
              </div>
              <p>Vous n'avez aucun article dans votre panier</p>
            </div>
          </div>

          <div
            id="showAllBill"
            @click="showAllBill"
            v-if="
              reserved_items_client.length != reserved_items.length || showAll
            "
          >
            <div class="showAllBill" v-if="!showAll">
              Afficher toute la facture
            </div>
            <div class="showAllBill" v-else>Afficher ma facture</div>
          </div>
          <!-- <table class="table table-image" id="cart_table">
            <tbody>
              <tr
                v-for="(item, index) in reserved_items"
                :key="`${item._id}_ddd`"
              >
                <td class="infos_td controls_container">
                  <span
                    >{{ item.title }} <br />{{ item.price
                    }}{{ currentCurrency.symbol }}</span
                  >
                </td>
                <td class="controls_container">
                  <div class="quantity">
                    <span class="minus" @click="SubstractQuanity(index)"
                      ><i class="fas fa-minus"></i
                    ></span>
                    <span class="quantity_value">{{ item.quantity }}</span>
                    <span class="plus" @click="AddQuanity(index)"
                      ><i class="fas fa-plus"></i
                    ></span>
                  </div>
                </td>
                <td  class="controls_container">
                  <div @click="RemoveItem(index)" class="quantity">
                    <i class="fa fa-trash remove"></i>
                  </div>
                </td>
              </tr>
            </tbody>
          </table> -->
        </div>

        <div
          class="modal-footer bottom_commande_cart"
          v-if="cart_button_text != 'Payer ma commande'"
        >
          <!-- <div class="covers">
            <img src="htttp://localhost:3333/new_images/cover.png"  alt="" srcset="">
            <div class="text">
              Nombre de personnes
            </div>
            <div class="covers_controls">
              <div @click="minusCovers" class="cover_control_minus">
                <span>-</span>
              </div>
              <div class="cover_control_qte">
                <span>{{covers}}</span>
              </div>
              <div @click="addCovers" class="cover_control_plus">
                <span>+</span>
              </div>

            </div>
          </div> -->
          <div id="button_commander" @click="showClientInfos">
            <div class="button_commander">
              {{ showAll ? "Payer la facture" : cart_button_text }}
            </div>
            <div class="total">
              {{ total * 1 + pourboir * 1 }}{{ currentCurrency.symbol }}
            </div>
          </div>
        </div>
        <div class="modal-footer bottom_commande_cart_half" v-else>
          <div
            class="button_commander_half"
            v-if="!commandeInit"
            @click="UpdateFact"
          >
            <div class="button_commander">
              {{
                `${
                  isNewOrder && (!order || !order[0])
                    ? "Commander"
                    : order[0].menuItems.length != reserved_items.length
                    ? "Envoyer ma nouvelle commande"
                    : "Fermer"
                }`
              }}
            </div>
            <div class="total">
              {{ total * 1 + pourboir * 1 }}{{ currentCurrency.symbol }}
            </div>
          </div>
          <div
            class="button_commander_half"
            v-if="(commandeInit && reserved_items_client.length) || showAll"
            @click="showClientInfos"
          >
            <div class="button_commander">
              {{ showAll ? "Payer la commande" : cart_button_text }}
            </div>
            <div class="total">
              {{ total * 1 + pourboir * 1 }}{{ currentCurrency.symbol }}
            </div>
          </div>
        </div>
      </div>
    </modal>

    <modal name="split" @opened="onOpened" @closed="onClosed">
      <div class="modal_content full_gray split_modal dark_modal">
        <div class="full full_gray">
          <div class="dark_header" @click="$modal.hide('split')">
            <img
              src="htttp://localhost:3333/new_images/orange_left_arrow.png"
              alt=""
              srcset=""
            />
          </div>

          <div class="split_message">
            <div class="split_message_text">
              <span>Selectionner</span>
              <span class="orange_circle"></span>
              <span class="orange_circle"></span>
            </div>
            <div class="split_message_text1">
              <span>vos articles</span>
              <span class="orange_circle"></span>
              <span class="orange_circle"></span>
            </div>
          </div>
          <div class="split_items">
            <template v-for="item in reserved_items">
              <div
                :class="`fact_item split_item  ${
                  values.includes(item._id) ? 'active' : ''
                }`"
                v-if="
                  item.player_id == player_id ||
                  item.player_id == null ||
                  showAll
                "
                :key="`${item._id}_split`"
                @click="triggerValues(item._id)"
              >
                <div class="fact_item_left">
                  <img
                    :src="`htttp://localhost:3333/uploads/menus-items/${item.image}`"
                    class="fact_item_image"
                    alt=""
                    srcset=""
                    v-if="item.image"
                  />
                  <img
                    src="htttp://localhost:3333/assets/img/notification-thumb-2.jpg"
                    class="fact_item_image"
                    alt=""
                    v-else
                    srcset=""
                  />

                  <div class="fact_item_infos">
                    <span class="fact_item_name"
                      >{{ item.title ? item.title : item.name }}
                    </span>
                    <span class="fact_item_price"
                      >{{ (item.unitPrice * item.quantity).toFixed(2) }}
                      {{ currentCurrency.symbol }}
                    </span>
                  </div>
                </div>
                <template v-if="cart_button_text != 'Payer ma commande'">
                </template>
                <template v-else>
                  <img
                    src="htttp://localhost:3333/new_images/split_check_active.png"
                    class="check_image"
                    alt=""
                    srcset=""
                    v-if="
                      values.includes(item._id) && reserved_items.length > 1
                    "
                  />
                  <img
                    src="htttp://localhost:3333/new_images/split_check.png"
                    class="check_image"
                    alt=""
                    srcset=""
                    v-if="
                      !values.includes(item._id) && reserved_items.length > 1
                    "
                  />
                </template>
              </div>
            </template>
          </div>
          <!-- <table class="table table-image" id="cart_table">
            <tbody>
              <tr
                v-for="(item) in reserved_items"
                :key="`${item._id}_split`"
              >
                <td class="infos_td">
                
                  <b-form-checkbox v-model="values"  :value="item._id" >{{ item.title }} ({{ item.price
                    }}{{ currentCurrency.symbol }})</b-form-checkbox>
       
                
                </td>
                
              </tr>
            </tbody>
          </table> -->
        </div>

        <div class="modal-footer bottom_commande_cart">
          <div
            id="showAllBill1"
            @click="showAllBill"
            v-if="
              reserved_items_client.length != reserved_items.length || showAll
            "
          >
            <div class="showAllBill" v-if="!showAll">
              Afficher toute la facture
            </div>
            <div class="showAllBill" v-else>Afficher ma facture</div>
          </div>
          <div id="button_commander" @click="$modal.show('payment')">
            <div class="button_commander">{{ cart_button_text }}</div>
            <div class="total">
              {{ total * 1 + pourboir * 1 }}{{ currentCurrency.symbol }}
            </div>
          </div>
        </div>
      </div>
    </modal>

    <modal name="client" @opened="onOpened" @closed="onClosed">
      <div class="modal_content full_gray">
        <div
          class="full full_gray"
          style="background-color: #264740; padding-top: 20px"
        >
          <div class="dark_header" @click="$modal.hide('client')">
            <img
              src="htttp://localhost:3333/new_images/orange_left_arrow.png"
              alt=""
              srcset=""
            />
          </div>
          <div class="client_form_conainer">
            <!--<div class="form-group client-form">
              <label for="nom">Nom</label>
              <input
                type="text"
                class="form-control"
                id="nom"
                v-model="client_form.nom"
                aria-describedby="nomHelp"
                placeholder=""
              />
            </div>
            <div class="form-group client-form">
              <label for="prenom">Prénom</label>
              <input
                type="text"
                class="form-control"
                id="prenom"
                v-model="client_form.prenom"
                aria-describedby="prenomHelp"
                placeholder=""
              />
            </div>
            <div class="form-group client-form">
              <label for="email">E-mail</label>
              <input
                type="email"
                class="form-control"
                v-model="client_form.email"
                id="email"
                aria-describedby="emailHelp"
                placeholder=""
              />
            </div>
            <div class="form-group client-form">
              <label for="phone">Téléphone</label>
              <input
                type="phone"
                class="form-control"
                id="phone"
                v-model="client_form.phone"
                aria-describedby="phoneHelp"
                placeholder=""
              />
            </div>
            <div class="form-group client-form">
              <label for="adresse">Adresse</label>
              <textarea
                class="form-control"
                id="adresse"
                v-model="client_form.adresse"
                rows="3"
              ></textarea>
            </div>-->
            <template v-if="!clientProg">
              <div
                class="google_fb"
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: 100%;
                "
              >
                <div class="google_login">
                  <GoogleLogin
                    :params="params1"
                    :renderParams="renderParams"
                    :onSuccess="onSuccess"
                    :onFailure="onFailure"
                  >
                  </GoogleLogin>
                </div>
                <div class="fb_login">
                  <v-facebook-login
                    @sdk-init="handleSdkInit"
                    @login="loginFacebook"
                    v-model="facebook"
                    app-id="1274685539667481"
                  ></v-facebook-login>
                </div>
              </div>
              <Login ref="loginForm" :CheckOrder="checkOrder" />
            </template>
            <template v-else>
              <div class="bonjour" style="color: #fff">
                <img
                  src="htttp://localhost:3333/tablette/icons/en.png"
                  class="client_image"
                  alt=""
                  srcset=""
                />
                <h1 style="margin: 20px 0 35px 0">
                  Bonjour <br />
                  {{ clientProg.nom }} {{ clientProg.prenom }}
                </h1>
                <p style="color: #fff">
                  Vous avez <strong>{{ calculPoints() }}</strong> de credit à
                  utiliser
                </p>
              </div>
            </template>
          </div>
        </div>
        <div
          class="modal-footer bottom_commande_cart bottom_commande_login"
          style="background-color: #264740"
        >
          <div
            id="client_save"
            @click="$modal.show('signup')"
            v-if="!clientProg"
            class="modal_button"
          >
            <div class="modal_button_text">Sign up</div>
          </div>
          <div id="client_save" @click="saveClient()" class="modal_button">
            <div class="modal_button_text">Suivant</div>
          </div>
        </div>
      </div>
    </modal>
    <modal name="signup" @opened="onOpened" @closed="onClosed">
      <div class="modal_content payment_modal full_gray dark_modal">
        <div class="dark_header" @click="$modal.hide('signup')">
          <img
            src="htttp://localhost:3333/new_images/orange_left_arrow.png"
            alt=""
            srcset=""
          />
        </div>
        <Signup />
      </div>
    </modal>
    <modal name="fidelite" @opened="onOpened" @closed="onClosed">
      <div class="modal_content payment_modal full_gray dark_modal">
        <div class="dark_header" @click="$modal.hide('fidelite')">
          <img
            src="htttp://localhost:3333/new_images/orange_left_arrow.png"
            alt=""
            srcset=""
          />
        </div>
        <div class="profile_client_page">
          <div class="profile_header">
            <div class="profile_title">Prog</div>
            <div class="profile_title1">Fidélité</div>
            <div class="profile_circle"></div>
            <div class="profile_circle1"></div>
            <div class="profile_circle2"></div>
          </div>
          <div class="peofile_account" v-if="clientProg && cltprg">
            <div class="dot_profile_page"></div>
            <div class="dot_profile_page1"></div>
            <div class="profile_picture">
              <span>{{ clientProg.nom[0] }} {{ clientProg.prenom[0] }}</span>
            </div>
            <div class="profile_infos">
              <span class="profile_name"
                >{{ clientProg.nom }} {{ clientProg.prenom }}</span
              >
              <span class="profile_email">{{ clientProg.email }}</span>
            </div>
          </div>
          <div
            class="programme_details"
            v-if="cltprg && clientProg && programmeMenu[0]"
          >
            <div class="nom_programme">
              <h2>{{ programmeMenu[0].nom_programme }}</h2>
            </div>
            <div class="points_montant">
              <div class="profile_point1">
                <div class="dot_profile_page2"></div>
                <div class="dot_profile_page4"></div>
                <span>Points Fidélité</span>
                <i class="fa-solid fa-star fa-2x"></i>
                <span>{{ calculPoints() }} pts</span>
              </div>
              <div class="profile_point1">
                <span>Solde Fidélité</span>
                <i class="fa-solid fa-face-tongue-money fa-2x"></i>
                <span>{{ pointsTomontant() }} $</span>
              </div>
            </div>
            <!--<div class="earn_programme">
              <div class="label_e_program">
                <span>GAIN</span>
              </div>
              <div class="points_e_program">
                <span>{{ programmeMenu[0].earn.point }}pts</span>
                <span>{{ programmeMenu[0].earn.value }}$</span>
              </div>
            </div>
            <hr />
            <div class="earn_programme">
              <div class="label_e_program">
                <span>CONSOMMATION</span>
              </div>
              <div class="points_e_program">
                <span>{{ programmeMenu[0].burn.point }}pts</span>
                <span>{{ programmeMenu[0].burn.value }}$</span>
              </div>
            </div>-->
          </div>
          <!--<div class="profile_points" v-if="clientProg && cltprg">
            <div class="profile_point1">
              <div class="dot_profile_page2"></div>
              <div class="dot_profile_page4"></div>
              <span>Vos points Fidélité</span>
              <i class="fa-solid fa-star fa-2x"></i>
              <span>{{ calculPoints() }} / {{ pointsTomontant() }}</span>
            </div>
          </div>-->
          <div v-if="cltprg && clientProg" class="gain_earn">
            <span>Vous gagnerez <span class="orange_point"></span></span>
            <span> {{ calculEarn() }} pts</span>
          </div>
          <div class="gain_consom" v-if="clientProg">
            <div class="gain" @click="showProg = true">Consommer</div>
            <div
              class="gain"
              v-if="showProg === false"
              @click="$modal.show('payment')"
            >
              Gagner
            </div>
            <div
              class="gain"
              v-if="showProg === true"
              @click="$modal.show('payment')"
            >
              Suivant
            </div>
          </div>
          <p v-if="!clientProg" class="payment_text">
            Connectez vous pour pouvoir bénéficier du programme de fidélité
          </p>

          <div
            class="modal-footer bottom_commande_cart bottom_commande_login"
            v-if="!clientProg"
            style="background-color: #264740"
          >
            <!--<div id="client_save" @click="$modal.show('client')" class="modal_button">-->
            <div
              id="client_save"
              @click="$modal.show('login')"
              class="modal_button"
            >
              <div class="modal_button_text">Login</div>
            </div>
            <div
              id="client_save"
              @click="
                $modal.hide('fidelite');
                $modal.show('split');
              "
              class="modal_button"
            >
              <div class="modal_button_text">Suivant</div>
            </div>
          </div>

          <!--<div v-if="showProg" class="pourboire">
            <span>Burn</span>
            <input
              type="text"
              v-model="ptsburn"
              placeholder="Burn"
              class="pourboire_input"
            />
          </div>-->
          <div v-if="showProg" class="pourboire">
            <span>Combien voulez vous consommer de votre solde ?</span>
            <div
              style="
                display: flex;
                flex-direction: row;
                width: 100%;
                align-items: center;
                justify-content: center;
              "
            >
              <input
                type="text"
                v-model="valueconsom"
                placeholder="Burn"
                class="pourboire_input"
              />
              <p style="margin: 0 20px">$</p>
            </div>
          </div>
          <div v-if="showProg" class="order_infos">
            <div class="order_infos_line1">
              <span>Points à consommer</span>
              <span>{{ discountvalue() }} points</span>
            </div>
            <!--<div v-if="showProg" class="order_infos">
            <div class="order_infos_line1">
              <span>Points</span>
              <span>{{ ptsburn }} points</span>
            </div>
            <div class="order_infos_line">
              <span>Burn<span class="orange_point"></span></span>
              <span>{{ burndiscount() }} {{ currentCurrency.symbol }}</span>
            </div>-->

            <div v-if="discount < total && dscnt" class="order_infos_line">
              <span>montant à payer<span class="orange_point"></span></span>
              <span>{{ discount }} {{ currentCurrency.symbol }}</span>
            </div>
          </div>
          <div v-if="!dscnt && clientProg" class="order_infos_line">
            <span>Total<span class="orange_point"></span></span>
            <span> {{ total }} {{ currentCurrency.symbol }}</span>
          </div>
        </div>
      </div>
    </modal>
    <modal name="payment" @opened="onOpened" @closed="onClosed">
      <div class="modal_content payment_modal full_gray dark_modal">
        <div class="dark_header" @click="$modal.hide('payment')">
          <img
            src="htttp://localhost:3333/new_images/orange_left_arrow.png"
            alt=""
            srcset=""
          />
        </div>

        <div class="full full_gray center paymement_buttons_full">
          <div class="split_message">
            <div class="split_message_text">
              <span>Mode de</span>
              <span class="orange_circle"></span>
              <span class="orange_circle"></span>
            </div>
            <div class="split_message_text1">
              <span>paiement</span>
              <span class="orange_circle"></span>
              <span class="orange_circle"></span>
            </div>
          </div>

          <p class="payment_text">
            Veuillez sélectionner votre mode de paiement préféré
          </p>

          <!-- <div class="payment_modes">
            <div @click="active_payment=0" :class="`payment_mode ${active_payment==0?'active':''}`">
              <span>Espece</span>
              <img src="htttp://localhost:3333/new_images/payment/cash.png" alt="" srcset="">
            </div>
            <div @click="active_payment=1" :class="`payment_mode ${active_payment==1?'active':''}`">
              <span>Carte </span>
              <img src="htttp://localhost:3333/new_images/payment/card.png" alt="" srcset="">
            </div>

            <div @click="()=>{active_payment=2;moneticoPayment()}" :class="`payment_mode ${active_payment==2?'active':''}  origin`">
              <span>Monetico</span>
              <img src="htttp://localhost:3333/new_images/payment/monetico.png" alt="" srcset="">
            </div>

            <div @click="active_payment=3" :class="`payment_mode ${active_payment==3?'active':''}`">
              <span>Bitcoin</span>
              <img src="htttp://localhost:3333/new_images/payment/bitcoin.png" alt="" srcset="">
            </div>

            <div @click="active_payment=4" :class="`payment_mode ${active_payment==4?'active':''}`">
              <span>Paypal</span>
              <img src="htttp://localhost:3333/new_images/payment/paypal.png" alt="" srcset="">
            </div>

            <div @click="active_payment=5" :class="`payment_mode ${active_payment==5?'active':''}`">
              <span>Google pay</span>
              <img src="htttp://localhost:3333/new_images/payment/google.png" alt="" srcset="">
            </div>

            <div @click="active_payment=6" :class="`payment_mode ${active_payment==6?'active':''}`">
              <span>Apple pay</span>
              <img src="htttp://localhost:3333/new_images/payment/apple.png" alt="" srcset="">
            </div>

          </div> -->
          <div class="payement_buttons_container">
            <div class="payement_buttons">
              <div
                @click="paiment_mode = 1"
                :class="`payment_button ${paiment_mode == 1 ? 'active' : ''}`"
              >
                <img
                  src="htttp://localhost:3333/new_images/payment/card.png"
                  alt=""
                  srcset=""
                />
              </div>
              <div
                @click="paiment_mode = 2"
                :class="`payment_button ${paiment_mode == 2 ? 'active' : ''}`"
              >
                <img
                  src="htttp://localhost:3333/new_images/payment/apple.png"
                  alt=""
                  srcset=""
                />
              </div>
              <div
                @click="paiment_mode = 3"
                :class="`payment_button ${paiment_mode == 3 ? 'active' : ''}`"
              >
                <img
                  src="htttp://localhost:3333/new_images/payment/google.png"
                  alt=""
                  srcset=""
                />
              </div>
              <div
                @click="paiment_mode = 4"
                :class="`payment_button ${paiment_mode == 4 ? 'active' : ''}`"
              >
                <img
                  src="htttp://localhost:3333/new_images/payment/paypal.png"
                  alt=""
                  srcset=""
                />
              </div>
              <!-- <div @click="paiment_mode=5" :class="`payment_button  ${paiment_mode==5?'active':''}`">
            <img src="htttp://localhost:3333/new_images/payment/clicandpay.png" class="clicandpay" alt="" srcset="">
          </div> -->

              <!-- <div class="paymement_button cash" @click="sendOrder(1)">
              
              <span>Espèce</span>
              <img src="htttp://localhost:3333/new_images/payment/cash.png" alt="" srcset="">
            </div>
           
            <div
              class="paymement_button card_monetico"
              @click="moneticoPayment()"
            >
              <span>Monetico</span>
              
              <img src="htttp://localhost:3333/new_images/payment/monetico.png" alt="" srcset="">
            </div>
            <div class="paymement_button bitcoin_card">
             
              <span>Bitcoin</span>
              <img src="htttp://localhost:3333/new_images/payment/bitcoin.png" alt="" srcset="">
            </div>
            <div class="paymement_button " @click="moneticoPayment()">
              <span>Carte bancaire</span>
              
              <img src="htttp://localhost:3333/new_images/payment/card.png" alt="" srcset="">
            </div>
            <div class="paymement_button " @click="initStripe()">
              <span>Stripe</span>
              
              <img src="htttp://localhost:3333/new_images/payment/card.png" alt="" srcset="">
            </div>
            <div class="paymement_button google_pay">
              <GooglePayButton
                id="google-pay-btn"
                :options="options"
                @payed="processPayment($event)"
                @cancel="handleCancel"
              />
            </div>
            
            <form id="payment-form" v-show="showStripe">
              <div id="card-element">
              </div>
              <button id="submit">
                <div class="spinner hidden" id="spinner"></div>
                <span id="button-text">Pay now</span>
              </button>
              <p id="card-error" role="alert"></p>
              <p class="result-message hidden">
                Payment succeeded, see the result in your
                <a href="" target="_blank">Stripe dashboard.</a> Refresh the
                page to pay again.
              </p>
            </form>
            <div class="paymement_button card paypal_button">
              <img
                src="htttp://localhost:3333/paypal.svg"
                alt=""
                class="paypal_payment_icon"
              />
              <PayPal
                :amount="total"
                :currency="currentCurrency.currency_code"
                :client="paypal"
                :button-style="aStyle"
                env="sandbox"
                @payment-authorized="authorized"
                @payment-completed="completed"
                @payment-cancelled="cancelled"
              >
              </PayPal>
            </div> -->
            </div>
          </div>
          <div class="payment_content">
            <div v-if="isRoomCharge" class="transfert_block">
              <p v-if="paiment_mode == 1">Payer par transfert chambre</p>
              <div @click="transfertChmabre()" class="payment_content_button">
                <span>Transfert chambre </span>
                <div class="arrow_right">
                  <span>></span>
                </div>
              </div>
            </div>
            <p v-if="paiment_mode == 1">Payer par carte</p>
            <!-- <div
              v-if="paiment_mode == 1 && modes.monetico"
              @click="moneticoPayment()"
              class="payment_content_button"
            >
              <span>Payer par carte </span>
              <div class="arrow_right">
                <span>></span>
              </div>
            </div>

            <div
              @click="
                () => {
                  sendOrder(3);
                }
              "
              class="payment_content_button"
            >
              <span>Payer par carte </span>
              <div class="arrow_right">
                <span>></span>
              </div>
            </div>
            <div
              v-if="paiment_mode == 1 && modes.stripe"
              @click="initStripe()"
              class="payment_content_button"
            >
              <span>Payer par carte </span>
              <div class="arrow_right">
                <span>></span>
              </div>
            </div>-->

            <div
              v-if="paiment_mode == 1"
              @click="moneticoC3()"
              class="payment_content_button"
            >
              <span>Payer par carte </span>
              <div class="arrow_right">
                <span>></span>
              </div>
            </div>

            <form
              id="payment-form"
              v-show="paiment_mode == 1 && modes.stripe && showStripe"
            >
              <div id="card-element"></div>
              <button id="submit">
                <div class="spinner hidden" id="spinner"></div>
                <span id="button-text">Pay now</span>
              </button>
              <p id="card-error" role="alert"></p>
              <p class="result-message hidden">
                Payment succeeded, see the result in your
                <a href="" target="_blank">Stripe dashboard.</a> Refresh the
                page to pay again.
              </p>
            </form>

            <p v-if="paiment_mode == 2">Payer par Apple Pay</p>
            <!-- <div v-if="paiment_mode==2" class="payment_content_button">
              <span>Payer par Apple Pay </span>
              <img src="htttp://localhost:3333/new_images/payment/apple.png" alt="" srcset="">
            </div> -->
            <template v-if="paiment_mode == 2">
              <apple-pay-button
                @click="applePay"
                buttonstyle="black"
                type="plain"
                locale="en"
              ></apple-pay-button>
            </template>
            <p v-if="paiment_mode == 3">Payer par Google Pay</p>
            <!-- <div v-if="paiment_mode==3" class="payment_content_button">
              <span>Payer par Google Pay </span>
              <img src="htttp://localhost:3333/new_images/payment/google.png" alt="" srcset="">
            </div> -->
            <template v-if="paiment_mode == 3">
              <GooglePayButton
                id="google-pay-btn"
                :options="options"
                @payed="processPayment($event)"
                @cancel="handleCancel"
              />
            </template>

            <p v-if="paiment_mode == 4">Payer par Paypal</p>

            <!-- <div v-if="paiment_mode==4" @click="initClicAndPay" class="payment_content_button">
              <span>Payer par Paypal </span>
              <img src="htttp://localhost:3333/new_images/payment/paypal.png" alt="" srcset="">
              
            </div>  -->

            <template v-if="paiment_mode == 4">
              <PayPal
                :amount="total"
                :currency="currentCurrency.currency_code"
                :client="paypal"
                :button-style="aStyle"
                env="sandbox"
                @payment-authorized="authorized"
                @payment-completed="completed"
                @payment-cancelled="cancelled"
                :braintree="braintreeSdk"
              ></PayPal>
            </template>

            <div
              v-if="paiment_mode == 1 && modes.clicandpay"
              @click="initClicAndPay"
              class="payment_content_button"
            >
              <span>Payer par Click&Pay </span>
              <img
                src="htttp://localhost:3333/new_images/payment/clicandpay.png"
                class="clicandpay"
                alt=""
                srcset=""
              />
            </div>

            <div
              v-if="clicToken"
              class="kr-embedded"
              kr-popin
              :kr-form-token="clicToken"
            >
              <!-- payment form fields -->
              <div class="kr-pan"></div>
              <div class="kr-expiry"></div>
              <div class="kr-security-code"></div>

              <!-- payment form submit button -->
              <button class="kr-payment-button"></button>

              <!-- error zone -->
              <div class="kr-form-error"></div>
            </div>
            <!-- <div :class="`kr_payment ${paiment_mode==5?'visible':''}`">
              <div   class="kr-embedded" 
                kr-form-token="DEMO-TOKEN-TO-BE-REPLACED">

                  <div class="kr-pan"></div>
                  <div class="kr-expiry"></div>
                  <div class="kr-security-code"></div>

                  <button class="kr-payment-button"></button>

                  <div class="kr-form-error"></div>
              </div>
            </div> -->

            <!-- <div class="confirm_send">
              <span>M’envoyer une facture par email</span>
            </div> -->
            <div class="pourboirs">
              <div
                :class="`pourboir_btn ${
                  pourboir == 1 && !showOther ? 'active' : ''
                } `"
                @click="setPourboir(1)"
              >
                1{{ currentCurrency.symbol }}
              </div>
              <div
                :class="`pourboir_btn ${
                  pourboir == 2 && !showOther ? 'active' : ''
                } `"
                @click="setPourboir(2)"
              >
                2{{ currentCurrency.symbol }}
              </div>
              <div
                :class="`pourboir_btn ${
                  pourboir == 3 && !showOther ? 'active' : ''
                } `"
                @click="setPourboir(3)"
              >
                3{{ currentCurrency.symbol }}
              </div>
              <div
                :class="`pourboir_btn ${
                  showOther && !showProg ? 'active' : ''
                } `"
                @click="(showOther = true), (showProg = false)"
              >
                Autre
              </div>
              <!-- <div
                v-if="cltprg && clientProg && programmeMenu[0]"
                :class="`pourboir_btn ${
                  showProg && !showOther ? 'active' : ''
                } `"
                @click="(showProg = true), (showOther = false)"
              >
                {{ programmeMenu[0].nom_programme }}
              </div>-->
            </div>
            <!--<div class="pourboire" v-if="showProg">
              <span>Burn</span>
              <input
                type="text"
                v-model="ptsburn"
                placeholder="Burn"
                class="pourboire_input"
              />
            </div> -->
            <div class="pourboire" v-if="showOther">
              <span>Pourboire</span>
              <input
                type="text"
                v-model="pourboir"
                placeholder="Pourboire"
                class="pourboire_input"
              />
            </div>

            <div class="order_infos">
              <!--
              <div v-if="showOther" class="order_infos_line1">
                <span>Pourboire</span>
                <span>{{ pourboir }} {{ currentCurrency.symbol }}</span>
              </div>-->

              <!-- <div v-if="showProg" class="order_infos_line1">
                <span>Points</span>
                <span>{{ ptsburn }} points</span>
              </div>-->

              <!--<div v-if="showOther" class="order_infos_line">
                <span>Total<span class="orange_point"></span></span>
                <span>{{ total * 1 + pourboir * 1
                }}{{ currentCurrency.symbol }}</span>
              </div>-->

              <!--<div v-if="showProg" class="order_infos_line">
                <span>Burn<span class="orange_point"></span></span>
                <span>{{ burndiscount() }} {{ currentCurrency.symbol }}</span>
              </div>
              <div v-if="showProg" class="order_infos_line">
                <span>Earn<span class="orange_point"></span></span>
                <span>{{ calculEarn() }} pts</span>
              </div>-->
            </div>
            <div
              v-if="client_reservation && client_reservation.total * 1 > 0"
              class="order_infos_line"
            >
              <span>Prépayé<span class="orange_point"></span></span>
              <span
                >{{ (client_reservation.total * 1).toFixed(2) }}
                {{ currentCurrency.symbol }}</span
              >
            </div>
            <div class="order_infos_line">
              <span>Total<span class="orange_point"></span></span>
              <span>
                {{ toFixed(total * 1 + total_check_discount * 1) }}
                {{ currentCurrency.symbol }}</span
              >
            </div>
            <div v-if="pourboir > 0" class="order_infos_line1">
              <span>Pourboire</span>
              <span>{{ pourboir }} {{ currentCurrency.symbol }}</span>
            </div>
            <div v-if="dscnt" class="order_infos_line">
              <span>Discount<span class="orange_point"></span></span>
              <span> - {{ valueconsom }} {{ currentCurrency.symbol }}</span>
            </div>

            <div v-if="total_check_discount != 0" class="order_infos_line">
              <span>Discount<span class="orange_point"></span></span>
              <span>
                - {{ total_check_discount }} {{ currentCurrency.symbol }}</span
              >
            </div>
            <div v-if="dscnt" class="order_infos_line">
              <span>Montant final<span class="orange_point"></span></span>
              <span>
                {{
                  (
                    discount -
                    (client_reservation && client_reservation.total * 1 > 0
                      ? client_reservation.total * 1
                      : 0)
                  ).toFixed(2)
                }}
                {{ currentCurrency.symbol }}</span
              >
            </div>
            <div v-else class="order_infos_line">
              <span>Montant final<span class="orange_point"></span></span>
              <span>
                {{
                  (
                    total -
                    (client_reservation && client_reservation.total * 1 > 0
                      ? client_reservation.total * 1
                      : 0) +
                    (pourboir > 0 ? pourboir * 1 : 0)
                  ).toFixed(2)
                }}
                {{ currentCurrency.symbol }}</span
              >
            </div>
          </div>
          <div class="loader">
            <div class="loader_container">
              <div class="lds-ripple">
                <div></div>
                <div></div>
              </div>
            </div>
          </div>

          <div class="payment_container">
            <form
              method="post"
              id="payment_form"
              ref="payment_form"
              action="https://p.monetico-services.com/test/paiement.cgi"
            >
              <input
                type="hidden"
                id="TPE"
                name="TPE"
                :value="
                  restaurant && restaurant.configurationPaiment
                    ? restaurant.configurationPaiment.tpe
                    : ''
                "
              />
              <input
                type="hidden"
                id="societe"
                name="societe"
                :value="
                  restaurant && restaurant.configurationPaiment
                    ? restaurant.configurationPaiment.societe
                    : ''
                "
              />
              <input type="hidden" id="lgue" name="lgue" value="FR" />
              <input type="hidden" id="version" name="version" value="3.0" />
              <input
                type="hidden"
                id="reference"
                name="reference"
                :value="config.ref"
              />
              <input type="hidden" id="date" name="date" :value="config.date" />
              <input
                type="hidden"
                id="montant"
                name="montant"
                :value="config.price"
              />
              <input
                type="hidden"
                id="contexte_commande"
                name="contexte_commande"
                :value="config.context"
              />
              <input
                type="hidden"
                id="libre"
                name="texte-libre"
                :value="config.desc"
              />
              <input type="hidden" id="MAC" name="MAC" :value="config.MAC" />
              <input
                type="hidden"
                id="url_retour_ok"
                name="url_retour_ok"
                :value="config.url_retour_ok"
              />
              <input
                type="hidden"
                id="url_retour_err"
                name="url_retour_err"
                :value="config.url_retour_err"
              />
            </form>
          </div>
        </div>
        <!-- <div class="modal-footer  bottom_commande_cart">
         
          <div id="payemnt_back" @click="$modal.hide('payment')">
            <span class="caret-left"><i class="fas fa-chevron-left"></i></span>
            <div class="button_commander">Retour</div>
          </div>
        </div> -->
      </div>
    </modal>

    <modal name="signature" @opened="onOpened" @closed="onClosed">
      <div class="modal_content full_gray transfertmodal dark_modal">
        <div class="full full_gray">
          <div class="success_messsages">
            <div class="success_message_text">
              <div class="orange_circle"></div>
              <span>Transfert</span>
            </div>
            <div class="success_message_text1">
              <div class="orange_circle"></div>
              <div class="orange_circle"></div>
              <div class="orange_circle"></div>
              <span>chambre!</span>
            </div>
          </div>
          <div class="success_message_transfer">
            <p class="reservation_code_title">Insert your reservation code</p>
            <p class="light_message">
              Si vous êtes le propriétaire de la réservation, remplissez le code
              reservation que vous avez reçu par e-mail
            </p>
            <div class="canvas_container">
              <canvas class="" id="canva"></canvas>
            </div>
            <div class="download_buttons pin_box">
              <div class="download_button pin_input" @click="SaveSignature">
                Confirmer
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="modal-footer full_modal_footer modal_buttons">
          <div id="success_back" @click="closeAll()" class="modal_button">
            <div class="modal_button_text">Fermer</div>
          </div>
        </div> -->
      </div>
    </modal>

    <modal name="transfert" @opened="onOpened" @closed="onClosed">
      <div class="modal_content full_gray transfertmodal dark_modal">
        <div class="full full_gray">
          <div class="success_messsages">
            <div class="success_message_text">
              <div class="orange_circle"></div>
              <span>Transfert</span>
            </div>
            <div class="success_message_text1">
              <div class="orange_circle"></div>
              <div class="orange_circle"></div>
              <div class="orange_circle"></div>
              <span>chambre!</span>
            </div>
          </div>
          <div class="success_message" v-if="operaReservation">
            <p>
              Bonjour Mr.{{
                operaReservation.reservationGuests[0].profileInfo.profile
                  .customer.personName[0].givenName
              }}
              {{
                operaReservation.reservationGuests[0].profileInfo.profile
                  .customer.personName[0].surname
              }}
            </p>
            <p class="light_message">
              roomType :
              {{ operaReservation.roomStay.currentRoomInfo.roomType }} <br />
              roomId : {{ operaReservation.roomStay.currentRoomInfo.roomId }}
              <br />
            </p>

            <div class="form-group client-form pin_box"></div>
            <div class="download_buttons pin_box">
              <div class="download_button pin_input" @click="OpenSignature">
                Confirmer
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>
    <modal name="reservation_code" @opened="onOpened" @closed="onClosed">
      <div class="modal_content full_gray transfertmodal dark_modal">
        <div class="full full_gray">
          <div class="success_messsages">
            <div class="success_message_text">
              <div class="orange_circle"></div>
              <span>Transfert</span>
            </div>
            <div class="success_message_text1">
              <div class="orange_circle"></div>
              <div class="orange_circle"></div>
              <div class="orange_circle"></div>
              <span>chambre!</span>
            </div>
          </div>
          <div class="success_message">
            <p>Insert your reservation code</p>
            <p class="light_message">
              Si vous êtes le propriétaire de la réservation, remplissez le code
              reservation que vous avez reçu par e-mail
            </p>

            <div class="form-group client-form pin_box">
              <input
                max="4"
                type="number"
                class="form-control pin_input"
                v-model="operaRef"
                id="pin"
                aria-describedby="pinHelp"
                placeholder="Reservation Code"
              />
            </div>
            <p class="error_pin" v-if="showOperaError">Code PIN invalide</p>
            <div class="download_buttons pin_box">
              <div class="download_button pin_input" @click="OpenTransfert">
                Confirmer
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>

    <modal name="pin" @opened="onOpened" @closed="onClosed">
      <div class="modal_content full_gray dark_modal">
        <div class="full full_gray">
          <div class="success_messsages">
            <div class="success_message_text">
              <div class="orange_circle"></div>
              <span>Confirmation</span>
            </div>
            <div class="success_message_text1">
              <div class="orange_circle"></div>
              <div class="orange_circle"></div>
              <div class="orange_circle"></div>
              <span>PIN!</span>
            </div>
          </div>
          <div class="success_message">
            <p>Cette table est réservée</p>
            <p class="light_message">
              Si vous êtes le propriétaire de la réservation, remplissez le code
              PIN que vous avez reçu par e-mail
            </p>

            <div class="form-group client-form pin_box">
              <input
                max="4"
                type="number"
                class="form-control pin_input"
                v-model="pin"
                id="pin"
                aria-describedby="pinHelp"
                placeholder="PIN"
              />
            </div>
            <p class="error_pin" v-if="showPinError">Code PIN invalide</p>
            <div class="download_buttons pin_box">
              <div class="download_button pin_input" @click="ConfirmePin">
                Confirmer
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="modal-footer full_modal_footer modal_buttons">
          <div id="success_back" @click="closeAll()" class="modal_button">
            <div class="modal_button_text">Fermer</div>
          </div>
        </div> -->
      </div>
    </modal>

    <modal name="rating" @opened="onOpened" @closed="onClosed">
      <div class="modal_content full_gray dark_modal">
        <div class="full full_gray">
          <div class="pending_message success_message">
            <div class="dark_header" @click="$modal.hide('pending')">
              <img
                src="htttp://localhost:3333/new_images/orange_left_arrow.png"
                alt=""
                srcset=""
              />
            </div>
            <div class="pending_title">
              <div class="pending_msg">
                <span>Commande</span>
                <span class="pending_circle"></span>
                <span class="pending_circle"></span>
              </div>

              <div class="pending_msg1">
                <span>reçue</span>
                <span class="pending_circle"></span>
                <span class="pending_circle"></span>
              </div>
            </div>

            <p>Qu’avez-vous pensé de votre restaurant ?</p>
            <div class="stars">
              <img
                @click="ambiancerating = 1"
                :src="
                  ambiancerating >= 1
                    ? `htttp://localhost:3333/new_images/star_active.png`
                    : `htttp://localhost:3333/new_images/star_white.png`
                "
                alt=""
                srcset=""
              />
              <img
                @click="ambiancerating = 2"
                :src="
                  ambiancerating >= 2
                    ? `htttp://localhost:3333/new_images/star_active.png`
                    : `htttp://localhost:3333/new_images/star_white.png`
                "
                alt=""
                srcset=""
              />
              <img
                @click="ambiancerating = 3"
                :src="
                  ambiancerating >= 3
                    ? `htttp://localhost:3333/new_images/star_active.png`
                    : `htttp://localhost:3333/new_images/star_white.png`
                "
                alt=""
                srcset=""
              />
              <img
                @click="ambiancerating = 4"
                :src="
                  ambiancerating >= 4
                    ? `htttp://localhost:3333/new_images/star_active.png`
                    : `htttp://localhost:3333/new_images/star_white.png`
                "
                alt=""
                srcset=""
              />
              <img
                @click="ambiancerating = 5"
                :src="
                  ambiancerating >= 5
                    ? `htttp://localhost:3333/new_images/star_active.png`
                    : `htttp://localhost:3333/new_images/star_white.png`
                "
                alt=""
                srcset=""
              />
            </div>

            <p>Qu’avez-vous pensé de notre service ?</p>
            <div class="stars">
              <img
                @click="servicerating = 1"
                :src="
                  servicerating >= 1
                    ? `htttp://localhost:3333/new_images/star_active.png`
                    : `htttp://localhost:3333/new_images/star_white.png`
                "
                alt=""
                srcset=""
              />
              <img
                @click="servicerating = 2"
                :src="
                  servicerating >= 2
                    ? `htttp://localhost:3333/new_images/star_active.png`
                    : `htttp://localhost:3333/new_images/star_white.png`
                "
                alt=""
                srcset=""
              />
              <img
                @click="servicerating = 3"
                :src="
                  servicerating >= 3
                    ? `htttp://localhost:3333/new_images/star_active.png`
                    : `htttp://localhost:3333/new_images/star_white.png`
                "
                alt=""
                srcset=""
              />
              <img
                @click="servicerating = 4"
                :src="
                  servicerating >= 4
                    ? `htttp://localhost:3333/new_images/star_active.png`
                    : `htttp://localhost:3333/new_images/star_white.png`
                "
                alt=""
                srcset=""
              />
              <img
                @click="servicerating = 5"
                :src="
                  servicerating >= 5
                    ? `htttp://localhost:3333/new_images/star_active.png`
                    : `htttp://localhost:3333/new_images/star_white.png`
                "
                alt=""
                srcset=""
              />
            </div>
            <p class="message_pending_infos">
              Votre rendez-vous culinaire se termine ? Scannez de nouveau le QR
              Code du menu pour passer au paiement :)
            </p>
          </div>
        </div>
        <div class="modal-footer modal_buttons">
          <div id="success_back" @click="passRating" class="modal_button">
            <div class="modal_button_text">Fermer</div>
          </div>
        </div>
      </div>
    </modal>

    <modal name="success" @opened="onOpened" @closed="onClosed">
      <div class="modal_content full_gray dark_modal">
        <div class="full full_gray">
          <div class="success_messsages">
            <div class="success_message_text">
              <div class="orange_circle"></div>
              <span>Paiement</span>
            </div>
            <div class="success_message_text1">
              <div class="orange_circle"></div>
              <div class="orange_circle"></div>
              <div class="orange_circle"></div>
              <span>effectué!</span>
            </div>
          </div>
          <div class="success_message">
            <p>
              Nous vous remercions pour votre commande. Nous espérons vous
              revoir bientôt !
            </p>
            <p class="light_message">
              Pour consulter votre facture, rendez-vous sur notre application ou
              sur votre boîte mail.
            </p>
            <div class="download_buttons">
              <div class="download_button" @click="startDownload">
                Telecharger
              </div>
              <div class="download_button" @click="sendEmail">
                Envoyer par email
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer full_modal_footer modal_buttons">
          <div id="success_back" @click="closeAll()" class="modal_button">
            <div class="modal_button_text">Fermer</div>
          </div>
        </div>
      </div>
    </modal>

    <modal name="error" @opened="onOpened" @closed="onClosed">
      <span class="close_modal close_modal_cart" @click="$modal.hide('error')">
        <div>
          <i class="fas fa-chevron-left"></i>
        </div>
      </span>
      <div class="modal_title cart_header">
        <span>Probleme</span>
      </div>
      <div class="modal_content full_gray">
        <div class="full full_gray">
          <div class="success_message">
            <img
              src="htttp://localhost:3333/azour/img/error.png"
              alt=""
              srcset=""
              class="error_img"
            />
            <p
              style="padding: 0px 24px"
              v-if="error_message.includes('Désolé,')"
              v-html="error_message"
            ></p>

            <p v-else>
              Vous pouvez avoir un problème avec le processus de commande <br />
              Merci d'essayer plus tard
            </p>
          </div>
        </div>
        <div class="modal-footer modal_buttons">
          <div
            id="success_back"
            @click="$modal.hide('error')"
            class="modal_button"
          >
            <div class="modal_button_text">Retour</div>
          </div>
        </div>
      </div>
    </modal>
    <modal name="error_payment" @opened="onOpened" @closed="onClosed">
      <span
        class="close_modal close_modal_cart"
        @click="$modal.hide('error_payment')"
      >
        <div>
          <i class="fas fa-chevron-left"></i>
        </div>
      </span>
      <div class="modal_title cart_header">
        <span>Probleme</span>
      </div>
      <div class="modal_content full_gray">
        <div class="full full_gray">
          <div class="success_message">
            <img
              src="htttp://localhost:3333/azour/img/error.png"
              alt=""
              srcset=""
              class="error_img"
            />

            <p>
              Votre paiement n'est pas terminé <br />
              Veuillez réessayer
            </p>
          </div>
        </div>
        <div class="modal-footer modal_buttons">
          <div
            id="success_back"
            @click="$modal.hide('error_payment')"
            class="modal_button"
          >
            <div class="modal_button_text">Retour</div>
          </div>
        </div>
      </div>
    </modal>

    <modal name="prepaiment" @opened="onOpened" @closed="onClosed">
      <div class="modal_content full_gray dark_modal prepaiment">
        <div class="full full_gray">
          <div class="pending_message success_message">
            <div class="dark_header" @click="$modal.hide('prepaiment')">
              <img
                src="htttp://localhost:3333/new_images/orange_left_arrow.png"
                alt=""
                srcset=""
              />
            </div>
            <div class="pending_title">
              <div class="pending_msg">
                <span>Paiement</span>
                <span class="pending_circle"></span>
                <span class="pending_circle"></span>
              </div>
            </div>
            <p class="prepaiment_title">
              Souhaitez-vous sélectionner vos articles à payer ?
            </p>

            <div class="prepaiment_buttons">
              <div @click="showAll = false" :class="!showAll ? `active` : ''">
                <span>Oui<i>.</i></span>
              </div>
              <div @click="showAll = true" :class="showAll ? `active` : ''">
                <span>Non<i>.</i></span>
              </div>
            </div>

            <p class="prepaiment_title">
              Souhaitez-vous diviser la note en {{ covers }} parts égales ?
            </p>
            <div class="prepaiment_buttons">
              <div
                @click="splitEqual = true"
                :class="splitEqual ? `active` : ''"
              >
                <span>Oui<i>.</i></span>
              </div>
              <div
                @click="splitEqual = false"
                :class="!splitEqual ? `active` : ''"
              >
                <span>Non<i>.</i></span>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer modal_buttons">
          <div
            id="confirm_prepaiment"
            @click="$modal.hide('pending')"
            class="modal_button"
          >
            <div class="modal_button_text">Confirmer.</div>
          </div>
        </div>
      </div>
    </modal>
    <modal name="pending" @opened="onOpened" @closed="onClosed">
      <div class="modal_content full_gray dark_modal">
        <div class="full full_gray">
          <div class="pending_message success_message">
            <div class="dark_header" @click="$modal.hide('pending')">
              <img
                src="htttp://localhost:3333/new_images/orange_left_arrow.png"
                alt=""
                srcset=""
              />
            </div>
            <div class="pending_title">
              <div class="pending_msg">
                <span>Commande</span>
                <span class="pending_circle"></span>
                <span class="pending_circle"></span>
              </div>

              <div class="pending_msg1">
                <span>reçue</span>
                <span class="pending_circle"></span>
                <span class="pending_circle"></span>
              </div>
            </div>
            <p>Qu’avez-vous pensé de votre restaurant ?</p>
            <div class="stars">
              <img
                @click="stars = 1"
                :src="
                  stars >= 1
                    ? `htttp://localhost:3333/new_images/star_active.png`
                    : `htttp://localhost:3333/new_images/star_white.png`
                "
                alt=""
                srcset=""
              />
              <img
                @click="stars = 2"
                :src="
                  stars >= 2
                    ? `htttp://localhost:3333/new_images/star_active.png`
                    : `htttp://localhost:3333/new_images/star_white.png`
                "
                alt=""
                srcset=""
              />
              <img
                @click="stars = 3"
                :src="
                  stars >= 3
                    ? `htttp://localhost:3333/new_images/star_active.png`
                    : `htttp://localhost:3333/new_images/star_white.png`
                "
                alt=""
                srcset=""
              />
              <img
                @click="stars = 4"
                :src="
                  stars >= 4
                    ? `htttp://localhost:3333/new_images/star_active.png`
                    : `htttp://localhost:3333/new_images/star_white.png`
                "
                alt=""
                srcset=""
              />
              <img
                @click="stars = 5"
                :src="
                  stars >= 5
                    ? `htttp://localhost:3333/new_images/star_active.png`
                    : `htttp://localhost:3333/new_images/star_white.png`
                "
                alt=""
                srcset=""
              />
            </div>

            <p class="message_pending_infos">
              Votre rendez-vous culinaire se termine ? Scannez de nouveau le QR
              Code du menu pour passer au paiement :)
            </p>
          </div>
        </div>
        <div class="modal-footer modal_buttons">
          <div id="success_back" @click="refreshAll" class="modal_button">
            <div class="modal_button_text">Fermer</div>
          </div>
        </div>
      </div>
    </modal>
    <modal name="loading" @opened="onOpened" @closed="onClosed">
      <div class="modal_content full_gray dark_modal prepaiment loader_modal">
        <div class="full full_gray">
          <div class="pending_message success_message">
            <!-- <img
              src="htttp://localhost:3333/azour/img/loading.gif"
              alt=""
              srcset=""
              class="loading_img"
            /> -->
            <!-- <p>
              S'il vous plaît soyez patient <br />
              votre demande est encour de traitement
            </p> -->

            <div class="pending_title">
              <div class="success_message_text">
                <div class="orange_circle"></div>
                <span>Operation</span>
              </div>
              <div class="success_message_text1">
                <div class="orange_circle"></div>
                <div class="orange_circle"></div>
                <div class="orange_circle"></div>
                <span>en cours</span>
              </div>
            </div>

            <div class="loader_container">
              <p class="prepaiment_title">
                Veuillez patienter votre opération sera bientôt terminée !
              </p>
              <div class="loader_animation">
                <div class="loader_line">
                  <div class="loader_line1"></div>
                </div>
                <div class="loader_circle"></div>
                <div class="loader_circle"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>

    <modal name="splash">
      <div
        class="modal_content full_gray dark_modal prepaiment loader_modal splash_modal"
      >
        <div class="full full_gray">
          <div class="pending_message success_message">
            <!-- <img
              src="htttp://localhost:3333/azour/img/loading.gif"
              alt=""
              srcset=""
              class="loading_img"
            /> -->
            <!-- <p>
              S'il vous plaît soyez patient <br />
              votre demande est encour de traitement
            </p> -->

            <div class="loader_container">
              <div class="pending_title_splash">
                <img
                  :src="`htttp://localhost:3333/logos/${restaurant.logo}`"
                  alt=""
                  :class="`splash_logo`"
                />

                <h2 class="">
                  <strong>{{ restaurant.name }}</strong>
                </h2>
              </div>
              <p class="prepaiment_title">Veuillez patienter !</p>
              <div class="loader_animation">
                <div class="loader_line">
                  <div class="loader_line1"></div>
                </div>
                <div class="loader_circle"></div>
                <div class="loader_circle"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>

    <modal name="expire" @opened="onOpened" @closed="onClosed">
      <span class="close_modal close_modal_cart" @click="$modal.hide('expire')">
        <div>
          <i class="fas fa-chevron-left"></i>
        </div>
      </span>
      <div class="modal_title cart_header">
        <span>Expire</span>
      </div>
      <div class="modal_content full_gray">
        <div class="full full_gray">
          <div class="success_message">
            <img
              src="htttp://localhost:3333/azour/img/expire.png"
              alt=""
              srcset=""
              class="expire_img"
            />

            <p>
              Votre session a expiré, <br />
              veuillez rescanner le QR code
            </p>
          </div>
        </div>
      </div>
    </modal>

    <modal name="askJoin" @opened="onOpened" @closed="onClosed">
      <!-- <span class="close_modal close_modal_cart" @click="$modal.hide('askJoin')">
        <div>
          <i class="fas fa-chevron-left"></i>
        </div>
      </span>
      <div class="modal_title cart_header">
        <span>Expire</span>
      </div> -->
      <div class="modal_content full_gray">
        <div class="full full_gray">
          <div class="success_message">
            <img
              src="htttp://localhost:3333/shield.png"
              alt=""
              srcset=""
              class="expire_img"
            />
            <h4>Quelqu'un utilise déjà cette table</h4>
            <h4>Peut-être votre ami ?</h4>
            <br />
            <h4>Souhaitez-vous rejoindre sa table ?</h4>
            <div class="ask_buttons">
              <div class="ask_button1" @click="$modal.hide('askJoin')">Non</div>
              <div class="ask_button" @click="sendRequest">Oui</div>
            </div>
            <!-- <p>
              Votre session a expiré, <br />
              veuillez rescanner le QR code
            </p> -->
          </div>
        </div>
      </div>
    </modal>
    <modal name="askJoinName" @opened="onOpened" @closed="onClosed">
      <div class="modal_content full_gray">
        <div class="full full_gray">
          <div class="success_message">
            <img
              src="htttp://localhost:3333/shield.png"
              alt=""
              srcset=""
              class="expire_img"
            />
            <h4>Monresto.menu !</h4>
            <h4>Super</h4>
            <br />
            <h4>Quel est votre nom ?</h4>
            <input placeholder="Name" class="join_name" v-model="clientName" />
            <div class="ask_buttons">
              <div class="ask_button1" @click="$modal.hide('askJoinName')">
                Annuler
              </div>
              <div class="ask_button" @click="sendClientName">Confirmer</div>
            </div>
          </div>
        </div>
      </div>
    </modal>
    <modal name="AcceptJoinRequest" @opened="onOpened" @closed="onClosed">
      <div class="modal_content full_gray">
        <div class="full full_gray">
          <div class="success_message">
            <img
              src="htttp://localhost:3333/shield.png"
              alt=""
              srcset=""
              class="expire_img"
            />
            <h4>Demande de connexion</h4>
            <h4>
              Bonjour {{ (client.nom || "") + " " + (client.prenom || "") }}
            </h4>
            <br />
            <h4>{{ requestJoin.nom }} veut rejoindre votre table</h4>
            <h4>Êtes-vous d'accord ?</h4>
            <div class="ask_buttons">
              <div
                class="ask_button1"
                @click="$modal.hide('AcceptJoinRequest')"
              >
                Annuler
              </div>
              <div class="ask_button" @click="acceptJoin">Confirmer</div>
            </div>
          </div>
        </div>
      </div>
    </modal>
    <modal name="askJoinWating" @opened="onOpened" @closed="onClosed">
      <!-- <span class="close_modal close_modal_cart" @click="$modal.hide('askJoinWating')">
        <div>
          <i class="fas fa-chevron-left"></i>
        </div>
      </span>
      <div class="modal_title cart_header">
        <span>Expire</span>
      </div> -->
      <div class="modal_content full_gray">
        <div class="full full_gray">
          <div class="success_message">
            <img
              src="htttp://localhost:3333/shield.png"
              alt=""
              srcset=""
              class="expire_img"
            />
            <h4>Monresto.menu !</h4>
            <h4>Veuillez patienter</h4>
            <br />
            <h4>Nous demandons une connexion ...</h4>

            <!-- <p>
              Votre session a expiré, <br />
              veuillez rescanner le QR code
            </p> -->
          </div>
        </div>
      </div>
    </modal>

    <!-- <div id="audio">
      <audio
        id="my_audio"
        src="https://freesound.org/data/previews/159/159583_2869798-lq.mp3"
      ></audio>
      <audio
        id="beep__hover"
        src="http://freesound.org/data/previews/263/263133_2064400-lq.mp3"
      ></audio>
    </div> -->
  </div>
</template>

<script>
var context = new AudioContext(); // Make it crossbrowser
import Login from "../progfidelite/Login.vue";
import Signup from "../progfidelite/Signup.vue";
import Orangedot from "../designs/Orangedot.vue";
import Bienvenue from "../designs/Bienvenue.vue";

// import ClientProfile from '../progfidelite/Compte_salon.vue'
// import HistoriqueProfile from '../progfidelite/Historique_salon.vue'
// import RestoInfo from '../wegets/options.vue'
import Navmenu from "../progfidelite/Navmenu.vue";
import { mapGetters, mapActions, mapMutations } from "vuex";
import PayPal from "vue-paypal-checkout";
const topicName = "chat";
import Axios from "axios";
import { SwipeList, SwipeOut } from "vue-swipe-actions";
import "vue-swipe-actions/dist/vue-swipe-actions.css";
import "./style.css";
import GoogleLogin from "vue-google-login";
import VFacebookLogin from "vue-facebook-login-component";
import GooglePayButton from "vue-google-pay";
import moment from "moment";
import axios from "axios";
export default {
  components: {
    // ClientProfile,
    // HistoriqueProfile,
    // RestoInfo,
    Navmenu,
    Login,
    Signup,
    Orangedot,
    Bienvenue,
    PayPal,
    SwipeOut,
    SwipeList,
    GoogleLogin,
    VFacebookLogin,
    GooglePayButton: GooglePayButton,
  },
  props: [
    "is_commande",
    "reserved_items",
    "currentCurrency",
    "SubstractQuanity",
    "AddQuanity",
    "RemoveItem",
    "restaurant",
    "hasModule",
    "hasCommande",
  ],
  data() {
    return {
      total_check_discount: 0,
      pourboir: 0,
      old_order1: {},
      requestJoin: {},
      clientName: "",
      commandeInit: true,
      image: "",
      signaturePad: null,
      operaReservation: null,
      showPinError: false,
      pin: "",
      showOperaError: false,
      operaRef: "722760",

      res_to_download: null,
      pourboir: 0,

      ptsburn: 0,
      progburn: 0,
      discount: 0,
      dscnt: false,
      ptsg: 0,
      valueconsom: 0,
      montant_client: 0,
      points_client: 0,

      ambiancerating: 0,
      servicerating: 0,

      showOther: false,
      showProg: false,

      paiment_mode: 1,
      reference_payment: null,
      active_payment: 0,
      splitEqual: false,
      stars: 0,
      covers: 1,
      options: {
        environment: "TEST",
        buttonColor: "white",
        allowedCardNetworks: [
          "AMEX",
          "DISCOVER",
          "INTERAC",
          "JCB",
          "MASTERCARD",
          "VISA",
        ],
        allowedCardAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
        merchantInfo: {
          merchantName: "Ihospitality",
          // merchantName: this.restaurant.googlepay.merchantName ? this.restaurant.googlepay.merchantName : "Ihospitality",
          // merchantName: this.restaurant.googlepay.merchantName,
          // merchantId: this.restaurant.googlepay.merchantId,
          // merchantId: this.restaurant.googlepay.merchantId ? this.restaurant.googlepay.merchantId : "BCR2DN4TZCGNJMLG",
          merchantId: "BCR2DN4TZCGNJMLG",
        },
        transactionInfo: {
          totalPriceStatus: "FINAL",
          totalPrice: "1.00",
          currencyCode: "EURO",
          countryCode: "FR",
        },
      },
      FB: {},
      facebook: {},
      params1: {
        client_id:
          "592182686828-tu4qq08ir4h83bo67hpo105um1fhhp77.apps.googleusercontent.com",
      },
      // only needed if you want to render the button with the google ui
      renderParams: {
        width: 250,
        height: 50,
        longtitle: true,
      },
      values: [],
      showAll: false,
      showStripe: false,
      cart_button_text: "Commander",
      stripe: {},
      client_form: {},
      config: {
        MAC: "",
        url_retour_ok: "",
        url_retour_err: "",
        price: "",
        currentDate: "",
        context: "",
        desc: "",
        ref: "",
      },
      data: [11, 2, 3, 4, 5],
      restau: {
        configurationPaiment: {},
      },
      aStyle: {
        label: "checkout",
        size: "large",
        color: "gold",
        // shape: 'rect',
        // color: 'black',
      },
      params: {},
      paypal_paiement: null,
      braintreeSdk: window.braintre,

      clicToken: null,
    };
  },
  watch: {
    leader(newVal, oldVal) {
      if (newVal && (!oldVal || !oldVal.leader)) {
        // alert(`${newVal.leader}!=${this.client._id} `)
        // if(newVal ){

        if (newVal.leader != this.client._id) {
          if (!newVal.participants.includes(this.client._id)) {
            this.$modal.show("askJoin");
          }
        }
      }
    },
    menus(newVal) {},
    client_reservation(newVal) {
      if (newVal) {
        if (newVal.status == "confirmed") {
          this.$modal.show("pin");
        }
      }
    },
    order(newVal) {
      console.log({newVal,"test":"test"})
      if (newVal && newVal.ref) {
        this.reference_payment = newVal.ref;
      }
    },
    client: function (newval) {
      this.client_form = Object.assign({}, { ...newval });

      let prams = window.location.href.split("?")[0].split("/");
      let pas = 1;
      let table = null;
      if (prams.length == 6) {
        table = prams[prams.length - 1];

        pas = 2;
      }

      let restaurant_ = prams[prams.length - (pas + 1)];
      let menu_ = prams[prams.length - pas];
      setTimeout(() => {
        this.CheckLeader({
          table,
          restaurant: restaurant_,
          menu: menu_,
          user_id: this.client._id,
        });
      }, 200);
    },
    isloadingOrder: function (newval) {
      if (newval) {
        this.$modal.show("loading");
      } else {
        this.$modal.hide("loading");
      }
    },
    payement_config: function (newVal) {
      if (newVal) {
        console.log(
          "payement_configpayement_configpayement_configpayement_config"
        );
        console.log(newVal);
        this.config = Object.assign({}, { ...newVal });
        setTimeout(() => {
          this.$refs.payment_form.submit();
        }, 500);
      }
    },
    reserved_items(newVal, oldVal) {
      let values = [];
      newVal.map((item) => {
        if (item.player_id !== undefined) {
          if (item.player_id == this.player_id) {
            values.push(item._id);
          }
        } else {
          if (item._id) values.push(item._id);
          else values.push(item.menuItemId);
        }
      });

      this.values = values;
    },
    // order(newVal,oldVal){
    //   if(!newVal){
    //     return;
    //   }
    //   this.cart_button_text  = "Payer ma commande"
    //   setTimeout(()=>{
    //     // this.$modal.show("split");

    //     if(!oldVal || !oldVal._id){
    //        this.$modal.show("cart");
    //     }

    //   },100)
    // }
    reserved_items_client(newVal, oldVal) {
      if (newVal.length > 0 && oldVal.length == 0 && this.order._id) {
        this.cart_button_text = "Payer ma commande";
        let exist = newVal.find((itm) => !itm._id);

        setTimeout(() => {
          if (!exist) {
            if (!window.location.href.includes("success=true")) {
              this.$modal.show("order");
            }
          }

          this.commandeInit = true;
          // this.$modal.show("split");
          // this.$modal.show("prepaiment");
          // this.$modal.show("cart");
        }, 10);
      }
    },
    total(newVal) {
      this.commandeInit = false;
      this.options = {
        // environment: 'PRODUCTION',
        environment: "TEST",
        buttonColor: "white",
        allowedCardNetworks: [
          "AMEX",
          "DISCOVER",
          "INTERAC",
          "JCB",
          "MASTERCARD",
          "VISA",
        ],
        allowedCardAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
        merchantInfo: {
          // merchantName: this.restaurant.googlepay.merchantName,
          // merchantId: this.restaurant.googlepay.merchantId,
          merchantName: "Ihospitality",
          merchantId: "BCR2DN4TZCGNJMLG",
        },
        transactionInfo: {
          totalPriceStatus: "FINAL",
          totalPrice: `${parseFloat(newVal + this.pourboir).toFixed(2)}`,
          currencyCode: this.currentCurrency.currency_code,
          countryCode: "FR",
        },
      };
    },
    pourboir(newVal, oldVal) {
      this.options = {
        // environment: 'PRODUCTION',
        environment: "TEST",
        buttonColor: "white",
        allowedCardNetworks: [
          "AMEX",
          "DISCOVER",
          "INTERAC",
          "JCB",
          "MASTERCARD",
          "VISA",
        ],
        allowedCardAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
        merchantInfo: {
          // merchantName: this.restaurant.googlepay.merchantName,
          // merchantId: this.restaurant.googlepay.merchantId,
          merchantName: "Ihospitality",
          merchantId: "BCR2DN4TZCGNJMLG",
        },
        transactionInfo: {
          totalPriceStatus: "FINAL",
          totalPrice: `${parseFloat(
            newVal +
              this.total -
              (this.client_reservation && this.client_reservation.total * 1 > 0
                ? this.client_reservation.total * 1
                : 0)
          ).toFixed(2)}`,
          currencyCode: this.currentCurrency.currency_code,
          countryCode: "FR",
        },
      };
    },
  },
  computed: {
    ...mapGetters([
      "leader",
      "isloadingCheckingLeader",
      "client_reservation",
      "client",
      "configuration",

      "order",
      "checkList",

      "old_order",
      "isloadingOrder",
      "payement_config",
      "error_message",
      "menus",
      "programmeMenu",
      "clientProg",
      "cltprg",
    ]),
    player_id() {
      return this.client ? this.client._id : null;
    },
    activeMenu() {
      return this.menus.find((itm) => itm.slugMenu == this.params.menu);
    },
    selectedTable() {
      return this.params.table;
    },
    paypal() {
      if (this.restaurant.modes) {
        if (this.restaurant.modes.paypal) {
          return {
            sandbox: this.restaurant.paypal.sandbox,
            production: this.restaurant.paypal.production,
          };
        }
      }
      return {
        sandbox: "",
        production: "",
      };
    },

    isRoomCharge() {
      if (!this.configuration) {
        return false;
      }
      return (
        this.configuration.selectedMediaChmabre &&
        this.configuration.selectedMediaChmabre.ObjectNumber
      );
    },
    modes() {
      if (this.restaurant.modes) {
        return this.restaurant.modes;
      }
      return {};
    },

    total_count() {
      let total = 0;
      this.reserved_items_client.map((item) => {
        console.log({ item: item });
        console.log({ total: total });
        total += item.quantity;
      });
      return total;
    },
    isNewOrder() {
      let istrue = true;
      this.reserved_items.map((itm, index) => {
        if (itm._id && this.player_id == itm.player_id) {
          istrue = false;
        }
      });
      return istrue;
    },
    reserved_items_client() {
      let items = [];

      this.reserved_items.map((itm, index) => {
        let price = itm.price ? itm.price : itm.unitPrice * 1;
        if (itm.player_id !== undefined && itm.player_id != null) {
          if (this.player_id == itm.player_id || this.showAll) {
            items.push({ ...itm, unitPrice: price, price: price, index });
          }
        } else {
          items.push({ ...itm, unitPrice: price, price: price, index });
        }
      });
      return items;
    },
    total: function () {
      let total = 0;
      this.values.map((id) => {
        // let item = this.reserved_items.find((res_item) => res_item._id == id);
        // let item = this.reserved_items.find((res_item) => res_item.menuItemId == id);
        let item = this.reserved_items.find((res_item) => {
          return res_item._id ? res_item._id == id : res_item.menuItemId == id;
        });
        total +=
          item.quantity * 1 * (item.price ? item.price : item.unitPrice * 1);
      });
      total -= this.total_check_discount;
      return total.toFixed(2);
    },
  },
  sockets: {
    connect: function () {
      console.log("socket connected");
    },
    triggerOrderReady(data) {
      if (this.clientProg._id == data._id) {
        alert("Votre commande est prête");

        var audio = new Audio("htttp://localhost:3333/ring1.mp3");
        audio.play();
      }
    },
    acceptRequestToJoin() {
      this.$modal.hide("askJoinWating");
      let prams = window.location.href.split("?")[0].split("/");
      let pas = 1;
      let table = null;
      if (prams.length == 6) {
        table = prams[prams.length - 1];
        pas = 2;
      }
      let restaurant_ = prams[prams.length - (pas + 1)];
      let menu_ = prams[prams.length - pas];
      this.CheckLeader({
        table,
        restaurant: restaurant_,
        menu: menu_,
        user_id: this.client._id,
        name: this.clientName,
        setName: true,
        socketId: this.$socket.id,
      });
      // this.$modal.show("SuccessJoin")
      this.$modal.hide("askJoinName");
    },
    JoinRequest: function (data) {
      this.requestJoin = data.guest;

      this.$modal.show("AcceptJoinRequest");

      console.log(data);
    },
    checkTableResult: function (data) {
      this.$modal.hide("splash");
      this.$modal.hide("loading");
      // this.$modal.hide("pending");
      // alert("yes")
      console.log({ data });
      if (data && data.data) {
        console.log("commitCheckTable");
        console.log({ data });
        this.commitCheckTable(data);

        this.res_to_download = data.data[data.data.length - 1];

        // alert("yes")
      }

      // console.log("checkTablePos")
    },

    newOrder: function (data) {
      // alert("yess")
      if (data.order) {
        this.res_to_download = data.order;
      }
      this.check_table_dispo();
    },
  },
  methods: {
    checkScreen() {
      if (this.order && this.order[0]) {
        if (this.order[0].menuItems.length == this.reserved_items.length) {
          if (!window.location.href.includes("success=true")) {
            this.$modal.show("order");
          }
          return;
        }
      }

      this.$modal.show("cart");
    },
    toFixed(val) {
      console.log({ val });
      return val.toFixed(2);
    },
    acceptJoin() {
      let prams = window.location.href.split("?")[0].split("/");
      let pas = 1;
      let table = null;
      if (prams.length == 6) {
        table = prams[prams.length - 1];
        pas = 2;
      }
      let restaurant_ = prams[prams.length - (pas + 1)];
      let menu_ = prams[prams.length - pas];
      if (table) {
        this.AcceptLeader({
          table,
          restaurant: restaurant_,
          menu: menu_,
          user_id: this.requestJoin._id,
        }).then(() => {
          this.$modal.hide("AcceptJoinRequest");
          this.CheckLeader({
            table,
            restaurant: restaurant_,
            menu: menu_,
            user_id: this.client._id,
            name: this.clientName,
            setName: true,
            socketId: this.$socket.id,
          });
        });
      }
    },
    sendClientName() {
      let prams = window.location.href.split("?")[0].split("/");
      let pas = 1;
      let table = null;
      if (prams.length == 6) {
        table = prams[prams.length - 1];
        pas = 2;
      }
      let restaurant_ = prams[prams.length - (pas + 1)];
      let menu_ = prams[prams.length - pas];
      if (table) {
        this.CheckLeader({
          table,
          restaurant: restaurant_,
          menu: menu_,
          user_id: this.client._id,
          name: this.clientName,
          setName: true,
          socketId: this.$socket.id,
        });
        this.$modal.show("askJoinWating");
      }
    },
    sendRequest() {
      this.$modal.hide("askJoin");
      if (!this.client.name || this.client.name == "") {
        this.$modal.show("askJoinName");
      } else {
        this.$modal.show("askJoinWating");
      }
    },
    SignIn() {
      let email = this.$refs.loginForm.email;
      let password = this.$refs.loginForm.password;

      const form = {
        email: email,
        password: password,
      };
      this.loginProg(form).then((res) => {
        if (res.ok) {
          // window.location.href = '/'
          // this.$router.push('/client')
          this.getClientProg();
          console.log(res.client);
          // this.addClientSuccess(res.client)
          // this.saveClient();
          // this.CheckOrder();
        }
        // this.$router.push('Login')
      });
    },
    fideliteorpay() {
      if (this.programmeMenu && this.programmeMenu[0]) {
        this.$modal.show("fidelite");
      } else this.$modal.show("split");
      // this.programmeMenu[0] ? this.$modal.show('fidelite') : this.$modal.show('payment')
    },
    OpenTransfert() {
      this.getOperaReservation(this.operaRef).then((res) => {
        console.log({ res });
        this.operaReservation = res.data.data.reservations.reservation[0];
        this.$modal.hide("reservation_code");
        this.$modal.show("transfert");
      });
    },
    SaveSignature() {
      if (this.signaturePad) {
        this.image = this.signaturePad.toDataURL();
        this.sendOrder(6);
      }
    },
    OpenSignature() {
      this.$modal.hide("transfert");
      this.$modal.show("signature");
      setTimeout(() => {
        const canvas = document.querySelector("canvas");
        console.log(canvas);
        this.signaturePad = new SignaturePad(canvas, {
          // dotSize:.2,
          minWidth: 0.5,
          maxWidth: 0.5,
          penColor: "black",
        });
      }, 600);
    },
    transfertChmabre() {
      this.$modal.show("reservation_code");
    },
    onBegin() {
      console.log("=== Begin ===");
    },
    onEnd() {
      console.log("=== End ===");
    },

    OverReservation() {
      let prams = window.location.href.split("?")[0].split("/");
      let pas = 1;
      let table = null;
      if (prams.length == 6) {
        table = prams[prams.length - 1];
        pas = 2;
      }

      let restaurant_ = prams[prams.length - (pas + 1)];
      // let menu_ = prams[prams.length - pas];
      if (this.client_reservation) {
        // let date = this.client_reservation.date;

        let newItem = {
          ...this.client_reservation,
          status: "over",
        };

        this.updateStatusReservation({
          restaurant: restaurant_,
          reservation: this.client_reservation._id,
          data: { ...newItem },
        });
      }
    },
    ConfirmePin() {
      if (!this.client_reservation) {
        return;
      }
      this.showPinError = false;
      if (this.client_reservation.pin == this.pin) {
        this.$modal.hide("pin");

        let prams = window.location.href.split("?")[0].split("/");
        let pas = 1;
        let table = null;
        if (prams.length == 6) {
          table = prams[prams.length - 1];
          pas = 2;
        }

        let restaurant_ = prams[prams.length - (pas + 1)];
        let menu_ = prams[prams.length - pas];

        let date = this.client_reservation.date;

        let newItem = {
          ...this.client_reservation,
          status: "seated",
        };

        this.updateStatusReservation({
          restaurant: restaurant_,
          reservation: this.client_reservation._id,
          data: { ...newItem },
        });
      } else {
        this.showPinError = true;
      }
    },

    calculPoints() {
      let ttl = 0;
      console.log("asdasdasdasdasdasd");
      console.log(this.cltprg);
      if (this.cltprg) {
        for (let i = 0; i < this.cltprg.length; i++) {
          if (!isNaN(this.cltprg[i].points)) {
            ttl = ttl + this.cltprg[i].points;
          }
        }
        if (ttl < 0) ttl = 0;
        this.points_client = ttl;
        console.log({ ttl });

        return ttl.toFixed(2);
      }
    },
    calculEarn() {
      if (!this.programmeMenu || !this.programmeMenu[0]) {
        return 0;
      }
      let earnpts = this.programmeMenu[0].earn.point;
      let earnvalue = this.programmeMenu[0].earn.value;
      let montant = this.total;
      let points_gagnes = (montant * earnpts) / earnvalue;
      this.ptsg = points_gagnes;
      return points_gagnes;
    },

    // burndiscount() {
    //   let ttl = this.calculPoints();
    //   let testtotal = (this.total * 50) / 100;
    //   console.log("total des points " + ttl);
    //   console.log("moitié du montant " + testtotal);
    //   console.log("PTSBURN " + this.ptsburn);
    //   if (ttl * 1 <= this.ptsburn * 1) {
    //     return "Vous avez dépassé vos points";
    //   } else if (ttl * 1 >= this.ptsburn * 1) {
    //     this.valueconsom =
    //       (this.ptsburn * this.programmeMenu[0].burn.value) /
    //       this.programmeMenu[0].burn.point;
    //     console.log("valueconsom " + this.valueconsom);
    //     this.discount = this.total * 1 - this.valueconsom;

    //     console.log(this.dscnt);
    //     if (this.discount * 1 < this.total * 1) {
    //       this.dscnt = true;
    //       console.log(this.dscnt);
    //     } else this.dscnt = false;
    //     return this.discount;
    //   } else if (this.discount * 1 < testtotal * 1) {
    //     return "Vous ne pouvez pas dépasser 50% du total";
    //   }
    // },
    discountvalue() {
      // let ttl = this.calculPoints();
      // let total = this.total;
      // if (this.discount > 0 && this.discount * 1 < this.total * 1) {
      //   this.valueconsom = total - this.discount;
      //   console.log("DISCOUNT DIFFERENCE : " + this.valueconsom);
      //   this.ptsburn =
      //     (this.valueconsom * this.programmeMenu[0].burn.point) /
      //     this.programmeMenu[0].burn.value;
      //   console.log("PTSBURN " + this.ptsburn);

      //   if (this.ptsburn <= ttl) {
      //     this.dscnt = true;
      //     return this.ptsburn.toFixed(2);
      //   } else if (this.ptsburn > ttl) {
      //     this.dscnt = false;
      //     return "Vous n'avez pas assez de ";
      //   } else this.dscnt = false;
      // } else if (this.discount * 1 <= 0 || this.discount * 1 == this.total) {
      //   this.dscnt = false;
      //   this.ptsburn = 0;
      //   return this.ptsburn;
      // } else if (this.discount * 1 > this.total) {
      //   this.dscnt = false;
      //   return "Vous avez dépassé le montant total";
      // }
      let solde = this.pointsTomontant();
      console.log("SOLDE : " + solde);
      if (
        this.valueconsom <= solde &&
        this.valueconsom > 0 &&
        this.programmeMenu &&
        this.programmeMenu[0]
      ) {
        this.ptsburn =
          (this.valueconsom * this.programmeMenu[0].burn.point) /
          this.programmeMenu[0].burn.value;
        this.discount = this.total - this.valueconsom;
        this.dscnt = true;
        return this.ptsburn.toFixed(2);
      } else if (this.valueconsom * 1 == 0) {
        this.ptsburn = 0;
        this.discount = 0;
        this.dscnt = false;
        return this.ptsburn.toFixed(2);
      } else {
        this.discount = 0;
        this.dscnt = false;
        return "Vous avez dépassé votre solde";
      }
    },
    pointsTomontant() {
      if (!this.programmeMenu || !this.programmeMenu[0]) {
        return 0;
      }
      this.montant_client =
        (this.points_client * this.programmeMenu[0].burn.value) /
        this.programmeMenu[0].burn.point;
      return this.montant_client.toFixed(2);
    },
    startDownload() {
      let param = {
        rvcRef: this.order[0].header.rvcRef,
        checkRef: this.order[0].header.checkRef,
        restaurant: this.$route.params.restaurant,
      };
      this.downloadFile(param);
    },
    sendEmail() {
      this.generateBill(this.res_to_download).then((res) => {
        this.sendBill(this.res_to_download);
      });
    },
    setPourboir(val) {
      this.pourboir = val;
      this.showOther = false;
    },
    async initClicAndPay() {
      let $this = this;
      if (!$this.reference_payment) {
        let rslt = await this.sendOrder(null, true);
      }
      let res = await Axios.post(
        "htttp://localhost:3333/api/v1/web/clicandpay",
        {
          amount:
            this.total * 1 +
            this.pourboir * 1 -
            (this.client_reservation && this.client_reservation.total * 1 > 0
              ? this.client_reservation.total * 1
              : 0),
          currency: this.currentCurrency.currency_code,
          orderId: $this.reference_payment,
          customer: {
            email: this.client_form.email
              ? client_form.email
              : "tfkizim@gmail.com",
          },
          Authorization:
            "Basic MzM2NTkxNjU6dGVzdHBhc3N3b3JkXzFnNkI4QUJ4a3hrUWJ5dWMxYWZzR3RBakFseFFBZU5PekUxZDVjQnU4MkZmMw==",
        },
        {}
      )
        .then(function (result) {
          return result.data;
        })
        .then(function (result) {
          return result.body;
        })
        .catch((err) => {
          console.log({ err });
        });
      // .then(function(data) {
      //   return data
      // })
      this.clicToken = res.answer.formToken;

      var my_awesome_script = document.createElement("script");

      let prams = window.location.href.split("?")[0].split("/");
      let pas = 1;
      let table = null;
      if (prams.length == 6) {
        table = prams[prams.length - 1];
        pas = 2;
      }
      let restaurant_ = prams[prams.length - (pas + 1)];
      let menu_ = prams[prams.length - pas];
      let return_url = `htttp://localhost:3333/${restaurant_}/${menu_}?ref=${$this.reference_payment}1`;
      if (table) {
        return_url = `htttp://localhost:3333/${restaurant_}/${menu_}/${table}?ref=${$this.reference_payment}1`;
      }

      my_awesome_script.setAttribute(
        "src",
        "https://api-clicandpay.groupecdn.fr/static/js/krypton-client/V4.0/stable/kr-payment-form.min.js"
      );
      my_awesome_script.setAttribute(
        "kr-public-key",
        "33659165:testpublickey_udUn5ozc6NwSbM3r479WfIJQkot5O1gWabElhClL3MJNY"
      );
      my_awesome_script.setAttribute("kr-get-url-success", return_url);

      document.head.appendChild(my_awesome_script);

      console.log({ res });
    },
    applePay() {
      // var request = {
      //     version:3,
      //     countryCode: 'FR',
      //     merchantIdentifier: 'merchant.devmonresto',
      //     currencyCode: this.currentCurrency.currency_code,
      //     supportedNetworks: ['visa', 'masterCard', 'amex', 'discover'],
      //     merchantCapabilities: ['supports3DS'],
      //     total: { label: 'Monresto.menu', amount: `${this.total}` },
      // }
      // var session = new   ApplePaySession(3, request);
      // console.log(session)

      // if (!ApplePaySession) {
      //     return;
      // }

      // Define ApplePayPaymentRequest
      const request = {
        countryCode: "FR",
        currencyCode: this.currentCurrency.currency_code,
        merchantCapabilities: [
          "supports3DS",
          "supportsCredit",
          "supportsDebit",
        ],
        supportedNetworks: ["visa", "masterCard", "amex", "discover"],
        total: {
          label: "Monresto.menu",
          type: "final",
          amount: `${parseFloat(
            this.total * 1 +
              this.pourboir * 1 -
              (this.client_reservation && this.client_reservation.total * 1 > 0
                ? this.client_reservation.total * 1
                : 0)
          ).toFixed(2)}`,
        },
      };

      // Create ApplePaySession
      const session = new ApplePaySession(3, request);

      session.onvalidatemerchant = async (event) => {
        // Call your own server to request a new merchant session.
        let restaurant = this.$route.params.restaurant;
        let merchantSession = await this.validateMerchant(
          event.validationURL,
          restaurant
        );
        merchantSession = JSON.parse(merchantSession.data.body.body);
        console.log({ merchantSession });
        // alert("onvalidatemerchant")
        session.completeMerchantValidation(merchantSession);

        // const result = {
        //     "status": ApplePaySession.STATUS_SUCCESS
        // };
        // console.log(result);
        // session.completePayment(result);
      };

      session.onpaymentmethodselected = (event) => {
        // Define ApplePayPaymentMethodUpdate based on the selected payment method.
        // No updates or errors are needed, pass an empty object.
        // alert("onpaymentmethodselected")
        const update = {};
        session.completePaymentMethodSelection({
          newTotal: request.total,
          newLineItems: [],
        });
      };

      session.onshippingmethodselected = (event) => {
        // Define ApplePayShippingMethodUpdate based on the selected shipping method.
        // No updates or errors are needed, pass an empty object.
        // alert("onshippingmethodselected")
        const update = {};
        session.completeShippingMethodSelection(update);
      };

      session.onshippingcontactselected = (event) => {
        // Define ApplePayShippingContactUpdate based on the selected shipping contact.
        // alert("onshippingcontactselected")
        const update = {};
        session.completeShippingContactSelection(update);
      };

      session.onpaymentauthorized = (event) => {
        // Define ApplePayPaymentAuthorizationResult
        // alert("onpaymentauthorized")
        // alert(JSON.stringify(ApplePaySession));
        const result = {
          status: ApplePaySession.STATUS_SUCCESS,
        };
        // alert("onpaymentauthorized")
        session.completePayment(result);
        this.sendOrder(3);
      };

      session.oncancel = (event) => {
        // Payment cancelled by WebKit
      };

      session.begin();
    },
    // async validateMerchant(url, restaurant) {
    async validateMerchant(url) {
      // return Axios.get(`htttp://localhost:3333/applePay/${restaurant}`);
      return Axios.get("htttp://localhost:3333/applePay");
      // return Axios.post("htttp://localhost:3333/applePay",{
      //     merchantIdentifier:"merchant.devmonresto",
      //     displayName:"Monresto",
      //     initiative:"web",
      //     initiativeContext:"demo.monresto.menu"
      // })
    },
    minusCovers() {
      if (this.covers > 1) {
        this.covers--;
      }
    },
    addCovers() {
      this.covers++;
    },
    processPayment(paymentData) {
      // process payment
      console.log(paymentData);
      this.sendOrder(3);
    },
    handleCancel() {
      // handle cancel event
    },
    handleSdkInit({ FB, scope }) {
      this.FB = FB;
      console.log({ FB, scope });
    },

    loginFacebook(user) {
      console.log(user);

      this.FB.api(
        `/${user.authResponse.userID}?fields=id,first_name,last_name,email,picture`,
        function (response) {
          console.log({ response });
          if (response && !response.error) {
            this.client_form = {
              nom: response.last_name,
              prenom: response.first_name,
              email: response.email,
              image: response.picture.data.url,
            };
          }
        }
      );
    },

    onSuccess(googleUser) {
      console.log(googleUser);
      console.log("getAuthResponse");
      console.log(googleUser.getAuthResponse());

      let user = googleUser.getBasicProfile();
      console.log({ user });
      this.client_form = {
        nom: user.getFamilyName(),
        prenom: user.getName(),
        email: user.getEmail(),
        image: user.getImageUrl(),
      };
      console.log(this.client_form);
    },
    onFailure(googleUser) {
      console.log(googleUser);

      // This only gets the user information: id, name, imageUrl and email
    },
    showAllBill() {
      this.showAll = !this.showAll;
    },
    onOpened() {
      window.scrollTo(0, 1);
      document.getElementsByTagName("html")[0].classList.add("modal-opened");
    },
    onClosed() {
      document.getElementsByTagName("html")[0].classList.remove("modal-opened");
    },
    contentClick(e) {
      console.log(e, "content click");
    },
    itemClick(e) {
      console.log(e, "item click");
    },
    itemDblClick(e) {
      console.log(e, "item double click");
    },
    fbClick(e) {
      console.log(e, "First Button Click");
    },
    sbClick(e) {
      console.log(e, "Second Button Click");
    },
    triggerValues(id) {
      if (this.cart_button_text != "Payer ma commande") {
        return;
      }
      if (this.values.includes(id)) {
        this.values.splice(this.values.indexOf(id), 1);
      } else {
        this.values.push(id);
      }
    },
    checkOrder() {
      let prams = window.location.href.split("?")[0].split("/");
      let pas = 1;
      let table = null;
      if (prams.length == 6) {
        table = prams[prams.length - 1];
        pas = 2;
      }
      if (table !== null) {
        this.sendOrder();
      } else {
        this.$modal.show("payment");

        //  this.$modal.show("order");
      }
    },
    UpdateFact() {
      if (this.order && this.order[0]) {
        if (this.order[0].menuItems.length == this.reserved_items.length) {
          this.$modal.hide("cart");
          return;
        }
      }
      this.sendOrder(null);
    },
    showClientInfos() {
      // alert("dd")
      if (this.order) {
        if (this.order._id) {
          this.$modal.show("split");
          // this.$modal.show('payment');
          return;
        }
      }
      console.log(window.location.href);

      this.$modal.show("client");

      // this.isValidSignature({url:window.location.href}).then((res)=>{
      //   console.log(res)
      //   if(res.valid){
      //     this.$modal.show('client')
      //   }else{
      //    this.$modal.show('client')
      //     // this.$modal.show("expire");
      //   }
      // })
    },
    async initStripe() {
      let $this = this;
      this.stripe = Stripe(this.restaurant.stripe.key);
      var elements = this.stripe.elements();
      var stripe = this.stripe;
      this.showStripe = true;
      document.getElementById("submit").disabled = true;
      if (!$this.reference_payment) {
        let rslt = await this.sendOrder(null, true);
      }

      fetch("htttp://localhost:3333/api/v1/web/create-payment-intent", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ref: $this.reference_payment,
          reserved_items: this.reserved_items,
          total:
            this.total * 1 +
            this.pourboir * 1 -
            (this.client_reservation && this.client_reservation.total * 1 > 0
              ? this.client_reservation.total * 1
              : 0),
          currency: this.currentCurrency.currency_code,
          restaurant: this.restaurant.slug,
        }),
      })
        .then(function (result) {
          return result.json();
        })
        .then(function (data) {
          var style = {
            base: {
              color: "#32325d",
              fontFamily: "Roboto, sans-serif",
              fontSmoothing: "antialiased",
              fontSize: "16px",
              "::placeholder": {
                color: "#32325d",
              },
            },
            invalid: {
              fontFamily: "Roboto, sans-serif",
              color: "#fa755a",
              iconColor: "#fa755a",
            },
          };
          var card = elements.create("card", { style: style });
          // Stripe injects an iframe into the DOM
          card.mount("#card-element");

          card.on("change", function (event) {
            // Disable the Pay button if there are no card details in the Element
            document.querySelector("#submit").disabled = event.empty;
            document.querySelector("#card-error").textContent = event.error
              ? event.error.message
              : "";
          });
          var form = document.getElementById("payment-form");
          form.addEventListener("submit", function (event) {
            event.preventDefault();
            // Complete payment when the submit button is clicked
            payWithCard(stripe, card, data.clientSecret);
          });
          var payWithCard = function (stripe, card, clientSecret) {
            loading(true);
            stripe
              .confirmCardPayment(clientSecret, {
                payment_method: {
                  card: card,
                },
              })
              .then(function (result) {
                console.log({ result });
                if (result.error) {
                  // Show error to your customer
                  showError(result.error.message);
                } else {
                  // The payment succeeded!
                  $this.getOrderbyRef({
                    ref: result.paymentIntent.description,
                    callback: (order) => {
                      console.log(order);
                      console.log("alksd;lasjljasldj;l");

                      $this.sendOrder(3);

                      // this.downloadFile(order);
                    },
                  });

                  orderComplete(result.paymentIntent.id);
                }
              });
          };
          /* ------- UI helpers ------- */
          // Shows a success message when the payment is complete
          var orderComplete = function (paymentIntentId) {
            loading(false);

            console.log(paymentIntentId);
            document
              .querySelector(".result-message a")
              .setAttribute(
                "href",
                "https://dashboard.stripe.com/test/payments/" + paymentIntentId
              );
            document
              .querySelector(".result-message")
              .classList.remove("hidden");
            document.querySelector("button").disabled = true;
          };
          // Show the customer the error from Stripe if their card fails to charge
          var showError = function (errorMsgText) {
            loading(false);
            var errorMsg = document.querySelector("#card-error");
            errorMsg.textContent = errorMsgText;
            setTimeout(function () {
              errorMsg.textContent = "";
            }, 4000);
          };
          // Show a spinner on payment submission
          var loading = function (isLoading) {
            if (isLoading) {
              // Disable the button and show a spinner
              document.querySelector("button").disabled = true;
              document.querySelector("#spinner").classList.remove("hidden");
              document.querySelector("#button-text").classList.add("hidden");
            } else {
              document.querySelector("button").disabled = false;
              document.querySelector("#spinner").classList.add("hidden");
              document.querySelector("#button-text").classList.remove("hidden");
            }
          };
        });
    },
    ...mapMutations(["addClientSuccess"]),
    ...mapActions([
      "AcceptLeader",
      "CheckLeader",
      "loginProg",
      "updateStatusReservation",
      "getReservationByTable",
      "getConfiguration",
      "addClient",
      "checkClient",
      "checkTable",
      "sendBill",
      "downloadFile",
      "generateBill",
      "postCheckGen2",
      "updateCheckGen2",
      "createOrder",
      "updateOrder",
      "getOrderbyRef",
      "getTablesDispos",
      "generatePaymentData",
      "isValidSignature",
      "commitCheckTable",
      "getOperaReservation",
      "getProgBymenu",
      "getClientProg",
      "earn",
      "rateserviceambiance",
      "getCheckListGn2",
    ]),
    accessCommande() {
      let flag = false;
      return true;
      if ((this.hasModule || this.hasCommande) && this.is_commande) {
        flag = true;
      } else {
        flag = false;
      }
      console.log("HEEEY : " + flag);
      console.log({
        hasModule: this.hasModule,
        hasCommande: this.hasCommande,
        is_commande: this.is_commande,
      });
      return flag;
    },
    authorized(param) {
      console.log("authorized");
      console.log(param);
    },
    completed(param) {
      console.log("completed");
      console.log(param);
      this.paypal_paiement = param;
      this.sendOrder(2);
    },
    cancelled(param) {
      console.log("cancelled");
      console.log(param);
    },
    sendUpdateOrder(payment, type_payement, data) {
      let newData = JSON.parse(JSON.stringify(data));
      newData.payment = payment;
      newData.order_id = this.order.CheckNum;
      newData.order_seq = this.order.CheckSeq;
      this.$modal.show("loading");
      this.updateOrder({
        data: newData,
      }).then((res) => {
        setTimeout(() => {
          this.$socket.emit("UpdateDefsSpecialCounts", {
            restaurant: this.params.restaurant,
            rvc: this.activeMenu.rvc,
          });
        }, 2000);

        if (res.ok === false) {
          this.$modal.show("error");
        } else if (
          payment * 1 !=
          this.configuration.selectedMediaEnvoi.ObjectNumber._text * 1
        ) {
          this.$modal.hide("payment");
          this.$modal.hide("client");
          this.$modal.hide("cart");
          this.$modal.hide("loading");
          this.$modal.hide("success");

          this.$modal.hide("prepaiment");
          // this.$modal.show("success");
          this.$modal.show("rating");

          // this.res_to_download = res;

          this.OverReservation();

          let dt;
          // if (this.discount < this.total)
          if (this.clientProg && this.programmeMenu[0]) {
            if (this.dscnt) {
              dt = {
                // total: data.total,
                menu: this.params.menu,
                restau: this.params.restaurant,
                client_id: this.clientProg._id,
                commande: this.order._id,
                programme: this.programmeMenu[0]._id,
                total: this.discount,
                points_consommes: this.ptsburn,
              };
            } else {
              // console.log(data.total)
              console.log(this.discount);
              console.log(this.total);
              dt = {
                total: this.total,
                menu: this.params.menu,
                restau: this.params.restaurant,
                client_id: this.clientProg._id,
                commande: this.order._id,
                programme: this.programmeMenu[0]._id,
                // total: this.discount,
                points_gagnes: this.ptsg,
              };
            }
            console.log("dt : ", dt);
            this.earn(dt);
          }

          // FONCTION GAGNER DES POINTS
          // this.earn({
          //   total: data.total,
          //   menu: this.params.menu,
          //   restau: this.params.restaurant,
          //   client_id: this.clientProg._id,
          // });

          // this.downloadFile(res); // active
        } else {
          this.$modal.hide("payment");
          this.$modal.hide("client");
          this.$modal.hide("cart");
          this.$modal.hide("loading");
          this.$modal.hide("success");

          this.$modal.hide("prepaiment");
          this.$modal.show("pending");
        }
      });

      // newData.rvc = $("#rvc").val();
    },
    async sendOrder(type_payement = null, is_payment = null) {
      // if (
      //   this.configuration.selectedMediaEscpece &&
      //   this.configuration.selectedTypeCommande
      // ) {
      // } else {
      //   this.$modal.show("error");
      //   return;
      // }

      this.$modal.show("loading");

      let prams = window.location.href.split("?")[0].split("/");
      let pas = 1;
      let table = null;
      if (prams.length == 6) {
        table = prams[prams.length - 1];
        pas = 2;
      }
      let restaurant_ = prams[prams.length - (pas + 1)];
      let menu_ = prams[prams.length - pas];
      let menu_items = [];
      let payment = "";
      console.log("%c CONFIGURATION", "color:font-size:28px;");
      console.log(this.configuration);
      if (this.configuration) {
        switch (type_payement) {
          case 1:
            // espece
            if (this.configuration.selectedMediaEscpece) {
              // return;
              payment =
                this.configuration.selectedMediaEscpece.ObjectNumber._text;
            } else {
              payment = "";
            }
            break;
          case 2:
            // paypal
            if (this.configuration.selectedMediaPaypal) {
              payment =
                this.configuration.selectedMediaPaypal.ObjectNumber._text;
            } else {
              payment = "";
            }

            break;
          case 3:
            // credit card
            if (this.configuration.selectedMediaCreditCard) {
              payment =
                this.configuration.selectedMediaCreditCard.ObjectNumber._text;
            } else {
              payment = "";
            }
            break;
          case 6:
            // credit card
            if (this.configuration.selectedMediaChmabre) {
              payment =
                this.configuration.selectedMediaChmabre.ObjectNumber._text;
            } else {
              payment = "";
            }

            //  if (this.configuration.selectedMediaEnvoi) {
            //   payment = this.configuration.selectedMediaEnvoi.ObjectNumber._text;
            // } else {
            //   payment = "";
            // }
            break;

          default:
            // send
            if (this.configuration.selectedMediaEnvoi) {
              payment =
                this.configuration.selectedMediaEnvoi.ObjectNumber._text;
            } else {
              payment = "";
            }
            break;
        }
      } else {
        payment = "";
      }

      if (
        ((!this.order || this.order._id) && this.values.length == 0) ||
        !this.params.table
      ) {
        this.values = this.reserved_items.map((itm) => itm._id);
      }

      let isUpdate = false;
      if (this.configuration) {
        isUpdate =
          payment == this.configuration.selectedMediaEnvoi?.ObjectNumber._text;
      }

      let total_order = 0;
      let total_pay = 0;
      this.values.map((id, index) => {
        if (
          !this.old_order1.menu_items ||
          this.old_order1.menu_items.length <= index
        ) {
          // let item = this.reserved_items.find((res_item) => res_item._id == id);
          // let item = this.reserved_items.find((res_item) => res_item.menuItemId == id);
          let item = this.reserved_items.find((res_item) => {
            return res_item._id
              ? res_item._id == id
              : res_item.menuItemId == id;
          });
          let price = item.price ? item.price : item.unitPrice;
          price = parseFloat(price).toFixed(2);

          total_order += price * 1;
          menu_items.push({
            MiMasterObjNum: item.objectNumber
              ? item.objectNumber
              : item.MiMasterObjNum
              ? item.MiMasterObjNum
              : item.menuItemId,
            price: price,
            quantity: item.quantity,
            player_id: this.client ? this.client._id : null,
            title: item.title ? item.title : item.name,
            discount: null,
          });

          if (!isUpdate) {
            total_pay += price * 1;
          }
        } else {
          let item = this.reserved_items.find((res_item) => {
            return res_item._id
              ? res_item._id == id
              : res_item.menuItemId == id;
          });
          let price = item.price ? item.price : item.unitPrice;
          price = parseFloat(price).toFixed(2);
          total_order += price * 1;
          if (!isUpdate) {
            total_pay += price * 1;
          }

          // menu_items.push(
          //   {
          //     MiMasterObjNum: item.objectNumber
          //       ? item.objectNumber
          //       : item.MiMasterObjNum ? item.MiMasterObjNum : item.menuItemId,
          //     price: price,
          //     quantity: item.quantity,
          //     player_id: this.client ? this.client._id : null,
          //     title: item.title ? item.title : item.name,
          //     discount: null,
          //   }
          // )
        }
      });

      // alert(`${this.configuration.selectedMediaEnvoi?.ObjectNumber._text} == ${payment}`)
      // alert(this.configuration.selectedMediaEnvoi?.ObjectNumber._text == payment)
      // alert(isUpdate)
      // alert(total_pay)
      // return

      let t = "";
      // if (this.hasCommande * 1 == 0) {
      //   t = "web";
      // }
      if (this.configuration && this.configuration.selectedTypeCommande) {
        t = this.configuration.selectedTypeCommande.OrdTypeID._text;
      } else {
        t = "web";
      }

      //

      let data = {
        menu: this.params.menu,
        menu_items,
        payment,
        isUpdate,
        state:
          this.values.length == this.reserved_items.length
            ? isUpdate
              ? 0
              : 1
            : 0,
        total: this.discount,
        pourboir: this.pourboir,
        type: t,
        user: 90029,
        image: this.image,
        operaRef: this.operaRef,
        restau: this.params.restaurant,
        table: this.params.table,
        CheckNum: this.order.CheckNum,
        CheckSeq: this.order.CheckSeq,
        client_id: this.clientProg ? this.clientProg._id : null,
        paypal_paiement: this.paypal_paiement,
        menu: menu_,
        values: menu_items.map((itm) => {
          return { item: itm };
        }),
        currency_code: this.currentCurrency.symbol,
        // discount: this.calculEarn
        discount: this.dscnt,
        discount_amount: this.valueconsom,
        servicerating: this.servicerating,
        ambiancerating: this.ambiancerating,
      };
      let tendersGen2 = [
        {
          tenderId: parseInt(payment),
          total: total_pay,
        },
      ];
      let dataGen2 = {
        menu: this.params.menu,
        menu_items,
        user: 90001,
        restaurant: this.params.restaurant,
        resto_slug: this.params.restaurant,
        values: menu_items.map((itm) => {
          return { item: itm };
        }),
        rvcRef: this.activeMenu.rvc,
        tableName: this.params.table,
        seat: this.params.table,
        payment: payment,
        tenders: tendersGen2,

        total: this.discount,
        menu: this.params.menu,
        client_id: this.clientProg ? this.clientProg._id : null,
      };
      let dataUpdateGen2 = {
        menu: this.params.menu,
        menu_items,
        user: 90001,
        restaurant: this.params.restaurant,
        resto_slug: this.params.restaurant,
        values: menu_items.map((itm) => {
          return { item: itm };
        }),
        rvcRef: this.activeMenu.rvc,
        tableName: this.params.table,
        seat: this.params.table,
        payment: payment,
        tenders: tendersGen2,

        total: this.discount,
        image: this.image,
        menu: this.params.menu,
        client_id: this.clientProg ? this.clientProg._id : null,
        status: total_pay == total_order ? "closed" : "open",
        checkRef: this.checkList?.items?.[0]?.header?.checkRef,
      };

      // console.log({dataUpdateGen2,data})
      // return
      // console.log({config:this.configuration})
      // return {ok:true}

      // console.log({dataUpdateGen2})
      // return;

      let isNewUpdate = false; // to check if scan the qrcode at the same time ( to add this items to the existing order )

      if (!this.order || !this.order._id) {
        //let re = await this.check_table_dispo();
        if (this.order) {
          isNewUpdate = isUpdate;
        }
      }

      data.isNewUpdate = isNewUpdate;

      if (this.order) {
        if (this.order._id) {
          return await this.sendUpdateOrder(payment, type_payement, data);
        }
      }
      if (this.checkList.items && this.checkList.items.length > 0) {
        // alert("test1")
        // return;
        return await this.updateCheckGen2({ dataUpdateGen2 }).then(() => {
          this.$modal.hide("payment");
          this.$modal.hide("client");
          this.$modal.hide("cart");
          this.$modal.hide("loading");
          this.$modal.hide("success");

          this.$modal.hide("prepaiment");
          // this.$modal.show("success");
          this.$modal.show("rating");
        });
      }

      // this.$socket.emit('receiveOrder', data)

      return await this.postCheckGen2({ dataGen2 }).then((res) => {
        if (type_payement == null) {
          if (is_payment) {
            this.reference_payment = res.ref;

            this.$modal.hide("loading");
          } else {
            this.$modal.hide("success");
            this.$modal.hide("payment");
            this.$modal.hide("client");
            this.$modal.hide("cart");
            this.$modal.hide("loading");
            this.$modal.hide("prepaiment");
            if (this.params.table) {
              this.$modal.show("pending");
            }
          }
        } else {
          this.$modal.hide("loading");
          this.$modal.hide("payment");
          this.$modal.hide("client");
          this.$modal.hide("cart");
          this.$modal.hide("loading");
          this.$modal.hide("prepaiment");
          // this.$modal.show("success");
          this.$modal.show("rating");

          // PROGRAMME FIDELITE FONCTION GAGNER ET CONSOMMER DES POINTS
          let dt;
          // if (this.discount < this.total)
          if (this.clientProg && this.programmeMenu[0]) {
            if (this.dscnt) {
              dt = {
                // total: data.total,
                menu: this.params.menu,
                restau: this.params.restaurant,
                client_id: this.clientProg._id,
                commande: res._id,
                programme: this.programmeMenu[0]._id,
                total: this.discount,
                points_consommes: this.ptsburn,
              };
            } else {
              console.log(data.total);
              console.log(this.discount);
              console.log(this.total);
              dt = {
                total: this.total,
                menu: this.params.menu,
                restau: this.params.restaurant,
                client_id: this.clientProg._id,
                commande: res._id,
                programme: this.programmeMenu[0]._id,
                // total: this.discount,
                points_gagnes: this.ptsg,
              };
            }
            console.log("dt : ", dt);
            this.earn(dt);
          }
          // this.downloadFile(res); //active
        }
      });
      return await this.createOrder({
        data,
        callback: (res) => {
          setTimeout(() => {
            console.log(this.$socket);
            console.log({
              restaurant: this.params.restaurant,
              rvc: this.activeMenu.rvc,
            });
            this.$socket.emit("UpdateDefsSpecialCounts", {
              restaurant: this.params.restaurant,
              rvc: this.activeMenu.rvc,
            });
          }, 2000);
          if (res.ok === false) {
            this.$modal.show("error");
          } else {
            // this.res_to_download = res;

            if (type_payement == null) {
              if (is_payment) {
                this.reference_payment = res.ref;

                this.$modal.hide("loading");
              } else {
                this.$modal.hide("success");
                this.$modal.hide("payment");
                this.$modal.hide("client");
                this.$modal.hide("cart");
                this.$modal.hide("loading");
                this.$modal.hide("prepaiment");
                if (this.params.table) {
                  this.$modal.show("pending");
                }
              }
            } else {
              this.$modal.hide("loading");
              this.$modal.hide("payment");
              this.$modal.hide("client");
              this.$modal.hide("cart");
              this.$modal.hide("loading");
              this.$modal.hide("prepaiment");
              // this.$modal.show("success");
              this.$modal.show("rating");

              // PROGRAMME FIDELITE FONCTION GAGNER ET CONSOMMER DES POINTS
              let dt;
              // if (this.discount < this.total)
              if (this.clientProg && this.programmeMenu[0]) {
                if (this.dscnt) {
                  dt = {
                    // total: data.total,
                    menu: this.params.menu,
                    restau: this.params.restaurant,
                    client_id: this.clientProg._id,
                    commande: res._id,
                    programme: this.programmeMenu[0]._id,
                    total: this.discount,
                    points_consommes: this.ptsburn,
                  };
                } else {
                  console.log(data.total);
                  console.log(this.discount);
                  console.log(this.total);
                  dt = {
                    total: this.total,
                    menu: this.params.menu,
                    restau: this.params.restaurant,
                    client_id: this.clientProg._id,
                    commande: res._id,
                    programme: this.programmeMenu[0]._id,
                    // total: this.discount,
                    points_gagnes: this.ptsg,
                  };
                }
                console.log("dt : ", dt);
                this.earn(dt);
              }
              // this.downloadFile(res); //active
            }
          }
          return res;
        },
      });
    },
    async moneticoC3() {
      alert("sss")
      let checkRef = this.checkList.items[0].header.checkRef;
      let totalDue = this.checkList.items[0].totals.totalDue;
      let response = await axios.post(
        "htttp://localhost:3333/api/3c-payment/initiate",
        {
          amount: totalDue * 100,
          currency: "EUR",
          orderId: checkRef,
          returnUrl:
            window.location.origin + window.location.pathname + "?success=true",
          cancelUrl:
            window.location.origin + window.location.pathname + "?failed=true",
        }
      );
      console.log(response);
      if (response.data && response.data.success) {
        let initData = response.data.data;
        let transactionId = initData.transactionId;
        // /api/3c-payment/process

        let processResponse = await axios
          .post("htttp://localhost:3333/api/3c-payment/process", {
            transactionId: transactionId,
            cardDetails: {
              cardNumber: "5500000000000004",
              expiryMonth: "06",
              expiryYear: "2028",
              cvv: "123",
              amount: totalDue * 100,
              currency: "EUR",
            },
          })
          .then((res) => res.data);
        console.log({ processResponse });

        if (processResponse.success) {
          location.href = processResponse.data.paymentUrl;
        } else {
          console.error("Error:", processResponse.message);
        }

        // http://192.168.100.225:8081/IHOSP-CLOUD-GEN2/Menu-1/3?failed=true&datatransTrxId=250716213142880566
        // http://192.168.100.225:8081/IHOSP-CLOUD-GEN2/Menu-1/3?success=true&datatransTrxId=250716213638480777
      }

      alert("Monetico C3 payment not implemented yet");
    },
    moneticoPayment() {
      let menu_items = [];
      let payment = "";
      let type = "web";
      if (this.configuration.selectedMediaCreditCard) {
        payment = this.configuration.selectedMediaCreditCard.ObjectNumber._text;
      }
      if (this.configuration.selectedTypeCommande) {
        type = this.configuration.selectedTypeCommande.OrdTypeID._text;
      }

      this.reserved_items.map((item) => {
        let price = item.price;
        price = parseFloat(price).toFixed(2);
        menu_items.push({
          MiMasterObjNum: item.objectNumber,
          price: price,
          quantity: item.quantity,
          title: item.title,
          discount: null,
        });
      });

      let data = {
        menu: this.params.menu,
        menu_items,
        payment,
        type: this.hasCommande * 1 == 0 ? "web" : type,
        user: 90029,
        restau: this.params.restaurant,
        table: this.params.table,
        CheckNum: this.order.CheckNum,
        CheckSeq: this.order.CheckSeq,
        reference: this.order.ref,
        pourboir: this.pourboir,
        client_id: this.clientProg ? this.clientProg._id : "",
        paypal_paiement: this.paypal_paiement,
        is_new_v: 1,
        currency_code: this.currentCurrency.symbol,
        // discount: this.calculEarn
        discount: this.dscnt,
      };

      this.generatePaymentData({
        data,
        callback: (res) => {
          if (res.ok === false) {
            this.$modal.show("error");
          } else {
            this.$refs.payment_form.submit();
            // this.$modal.show('success')
            // this.downloadFile(res);
          }
        },
      });
    },
    saveClient() {
      // let params = {
      //   client: { ...this.client_form, restaurant: this.restaurant.slug },
      // };
      // if (this.player_id) {
      //   params.client.key = this.player_id;
      // }
      // this.addClient(params).then((res) => {

      // });

      this.checkOrder();
    },
    closeAll() {
      let url = window.location.href.split("?")[0];
      // this.$modal.hide("success");
      // this.$modal.show("loading");

      window.location.href = url;
      // setTimeout(() => {
      //   this.check_table_dispo();
      // }, 2000);
    },
    refreshAll() {
      let url = window.location.href.split("?")[0];
      // this.$modal.hide("success");
      // this.$modal.show("loading");

      window.location.href = url;
      // window.location.reload();

      //this.$modal.show("loading");

      // // window.location.href = url;
      // setTimeout(() => {
      //   this.check_table_dispo();
      // }, 2000);
    },

    passRating() {
      if (this.order) {
        let payload = {
          order_id: this.order._id,
          ambiancerating: this.ambiancerating,
          servicerating: this.servicerating,
        };
        this.rateserviceambiance(payload);
      }

      this.$modal.hide("pending");
      if (this.order[0].menuItems.length != this.reserved_items.length) {
        this.closeAll();
      } else {
        this.$modal.show("success");
      }
      //
      // Hamza
    },

    closeAllPopups() {
      this.$modal.hide("order");
      this.$modal.hide("success");
      this.$modal.hide("payment");
      this.$modal.hide("client");
      this.$modal.hide("cart");
      this.$modal.hide("loading");
      // this.$modal.hide("pending");
      this.$modal.hide("expire");
      this.$modal.hide("prepaiment");
    },
    check_table_dispo() {
      let prams = window.location.href.split("?")[0].split("/");
      let pas = 1;
      let table = null;
      if (prams.length == 6) {
        table = prams[prams.length - 1];
        pas = 2;
      }
      let restaurant_ = prams[prams.length - (pas + 1)];
      let menu_ = prams[prams.length - pas];
      this.params = {
        restaurant: restaurant_,
        menu: menu_,
        table: table,
      };

      this.$socket.emit("checkTable", {
        restaurant: restaurant_,
        table,
        menu: menu_,
        client_id: this.client ? this.client._id : null,
      });

      // return this.checkTable({
      //   restaurant: restaurant_,
      //   table,
      //   menu: menu_,
      //   client_id: this.player_id,
      // }).then((res) => {
      //   this.$modal.hide("splash");
      //   return res;
      // });
    },
  },

  mounted() {
    console.log("this.$socket");
    console.log(this.$socket);
    let prams1 = window.location.href.split("?")[0].split("/");
    let pas1 = 1;

    let restaurant = this.$route.params.restaurant;
    let tableName = null;
    if (prams1.length == 6) {
      tableName = prams1[prams1.length - 1];

      pas1 = 2;
    }
    let payload = {
      restaurant: restaurant,
      resto_slug: restaurant,
      // rvcRef: 101,
      tableName: tableName,
      menu: this.$route.params.menu,
    };
    this.$modal.hide("order");
    this.getCheckListGn2(payload).then(() => {
      console.log({ checkList: this.checkList });
      if (this.checkList.items.length > 0) {
        console.log({ ordergen2: this.checkList.items[0] });
        this.reserved_items = this.checkList.items[0].menuItems;
        // alert("dddd")
        if (this.checkList.items[0].totals.subtotalDiscountTotal != 0) {
          this.total_check_discount =
            -1 * this.checkList.items[0].totals.subtotalDiscountTotal;
        }
        this.old_order1 = { menu_items: this.checkList.items[0].menuItems };
        this.cart_button_text = "Payer ma commande";

        if (window.location.href.includes("success=true")) {
          this.$modal.hide("order");
          setTimeout(() => {
            this.$modal.hide("order");
            let queryString = window.location.search;
            let urlParams = new URLSearchParams(queryString);
            let datatransTrxId = urlParams.get("datatransTrxId");
            if (datatransTrxId && this.checkList.items.length > 0) {
              axios
                .post(`htttp://localhost:3333/api/3c-payment/verify`, {
                  transactionId: datatransTrxId,
                })
                .then((res) => {
                  console.log(res.data);
                  if (res.data.success && res.data.data.status === "settled") {
                    setTimeout(() => {
                      this.sendOrder(3);
                    }, 900);
                  } else {
                    this.$modal.show("error_payment");
                  }
                })
                .catch((err) => {
                  console.error(err);
                  this.$modal.show("error_payment");
                });
              // this.isValidSignature({
              //   data: { datatransTrxId },
              //   callback: (res) => {
              //     if (res.ok) {
              //       this.$modal.show("success");
              //     } else {
              //       this.$modal.show("error_payment");
              //     }
              //   },
              // });
            } else {
              // this.$modal.show("success");
              this.$modal.show("order");
            }
          }, 200);
        }
        {
          this.$modal.show("order");
        }
      }
    });

    // this.$modal.show('askJoin')
    this.getProgBymenu({
      restaurant: this.$route.params.restaurant,
      menu: this.$route.params.menu,
    });
    this.getClientProg();
    let prams = window.location.href.split("?")[0].split("/");
    let pas = 1;
    let table = null;
    if (prams.length == 6) {
      table = prams[prams.length - 1];

      pas = 2;
    }

    let restaurant_ = prams[prams.length - (pas + 1)];
    let menu_ = prams[prams.length - pas];
    this.params = {
      restaurant: restaurant_,
      menu: menu_,
      table: table,
    };
    this.getConfiguration(restaurant_);
    // this.checkClient(restaurant_);

    // let dateChecked = new Date().toISOString().split("T")[0];
    //       let heure =  moment().format("HH:mm");
    //       let data = this.getTablesDispos({
    //         slug: this.$route.params.restaurant,
    //         date: dateChecked,
    //         heure: heure,
    //         rvc: this.rvc.value,
    //     });
    // this.$modal.show("order");
    this.$modal.show("clicnt");

    if (table !== null) {
      this.$modal.show("splash");
      let hour = moment().format("HH:");
      // hour = "16:";
      this.getReservationByTable({ table, hour, restaurant: restaurant_ });

      setTimeout(() => {
        this.check_table_dispo();
      }, 10);

      setTimeout(() => {
        this.$modal.hide("splash");
      }, 400);
    } else {
      // alert("ss")

      this.$modal.hide("splash");
    }

    if (
      window.location.href.split("?")[1] &&
      window.location.href.includes("ref=")
    ) {
      const queryString = window.location.search;

      const urlParams = new URLSearchParams(queryString);
      let ref = urlParams.get("ref").substr(0, urlParams.get("ref").length - 1);
      let status = urlParams.get("ref").slice(-1);
      // alert(ref)
      if (status == 1) {
        // this.$modal.show("success");
      } else {
        this.$modal.show("error_payment");
      }
      this.getOrderbyRef({
        ref,
        callback: (order) => {
          console.log(order);
          console.log("alksd;lasjljasldj;l");

          if (status == 1) {
            setTimeout(() => {
              this.sendOrder(3);
            }, 1000);

            // this.downloadFile(order);
          }
        },
      });
    }
    // console.log({AACCCTTTIIIVVVEEE_MENU : this.activeMenu.rvc})

    // CHECK THE PAYMENT STATUS

    // http://192.168.100.225:8081/IHOSP-CLOUD-GEN2/Menu-1/3?failed=true&datatransTrxId=250716213142880566
    // http://192.168.100.225:8081/IHOSP-CLOUD-GEN2/Menu-1/3?success=true&datatransTrxId=250716213638480777
    // if (window.location.href.includes("success=true")) {
    //   setTimeout(() => {
    //   let queryString = window.location.search;
    //   let urlParams = new URLSearchParams(queryString);
    //   let datatransTrxId = urlParams.get("datatransTrxId");
    //   if (datatransTrxId && this.checkList.items.length > 0) {
    //       axios
    //       .post(
    //         `htttp://localhost:3333/api/3c-payment/verify`,
    //         { transactionId: datatransTrxId }
    //       )
    //       .then((res) => {
    //         console.log(res.data);
    //         if(res.data.success && res.data.data.status === "settled") {

    //            this.sendOrder(3);

    //         } else {
    //           this.$modal.show("error_payment");
    //         }
    //       })
    //       .catch((err) => {
    //         console.error(err);
    //         this.$modal.show("error_payment");
    //       });
    //     // this.isValidSignature({
    //     //   data: { datatransTrxId },
    //     //   callback: (res) => {
    //     //     if (res.ok) {
    //     //       this.$modal.show("success");
    //     //     } else {
    //     //       this.$modal.show("error_payment");
    //     //     }
    //     //   },
    //     // });
    //   } else {
    //     // this.$modal.show("success");
    //   }
    //   }, 1000);
    // } else if (window.location.href.includes("failed=true")) {
    //   this.$modal.show("error_payment");
    // }
  },
  created() {
    // this.$ws.$on(`START_ORDER`, (d) => {});
  },
};
</script>

<style>
#audio {
  /* opacity: 0;
  width: 1px;
  height: 1px;
  overflow: hidden; */
}

.profile_client_page {
  width: 100%;
  padding: 24px 12px;
  /* padding-top: 52px; */
  /* margin-bottom: 120px; */
  color: #fff;
}

.profile_header {
  display: flex;
  flex-direction: column;
  flex: 2;
  justify-content: center;
  align-items: flex-start;
  padding-left: 24px;
  position: relative;
}

.profile_title {
  font-size: 62px;
  font-weight: bold;
}

.profile_title1 {
  font-size: 62px;
  font-weight: bold;
  transform: rotate(5deg);
  position: relative;
  bottom: 20px;
}

.profile_circle {
  display: block;
  position: absolute;
  width: 25px;
  height: 25px;
  background: #f05d2e;
  border-radius: 50%;
  top: 26%;
  left: 13px;
}

.profile_circle1 {
  display: block;
  position: absolute;
  width: 25px;
  height: 25px;
  background: #f05d2e;
  border-radius: 50%;
  top: 41%;
  left: 120px;
}

.profile_circle2 {
  display: block;
  position: absolute;
  width: 25px;
  height: 25px;
  background: #f05d2e;
  border-radius: 50%;
  top: 62%;
  left: 19%;
}

.peofile_account {
  background: #fff;
  padding: 24px 12px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-radius: 5px;
  color: #264740;
  position: relative;
}

.profile_picture {
  background: #f05d2e;
  width: 65px;
  height: 65px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.profile_picture span {
  color: #fff;
  font-size: 18px;
  font-weight: bold;
}

.profile_infos {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding-left: 12px;
}

.profile_name {
  font-size: 20px;
  font-weight: bold;
  margin: 0px;
}

.profile_email {
  font-size: 14px;
  margin: 0px;
}

.profile_action {
  display: flex;
  justify-content: center;
  align-items: center;
}

.profile_points {
  padding-top: 36px;
  padding-bottom: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
}

.points_montant {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
}

.profile_point1 {
  /* flex: 1; */
  padding: 30px 30px;
  /* background: #fff; */
  color: #f05d2e;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* border-radius: 50%; */
  font-weight: 600;
  position: relative;
}

.profile_point1 i {
  color: #f05d2e;
}

.dot_profile_page {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #f05d2e;
  position: absolute;
  top: -10%;
  right: 10%;
}

.dot_profile_page1 {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #f05d2e;
  position: absolute;
  top: 90%;
  left: 20%;
}

.dot_profile_page2 {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #f05d2e;
  position: absolute;
  top: 75%;
  left: 80%;
}

.dot_profile_page4 {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #f05d2e;
  position: absolute;
  top: -10%;
  left: 120%;
}

.programme_details {
  padding: 14px 0;
  color: #f05d2e;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  border-radius: 5px;
  margin-top: 36px;
}

.programme_details hr {
  /* border-top: 3px solid #264740;
  border-bottom: 3px solid #264740; */
  border-color: #264740;
  background-color: #264740;
  width: 50%;
  display: flex;
  align-self: center;
}

.nom_programme {
  background-color: #f05d2e;
  color: #fff;
  font-weight: 600;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 10px;
}

.nom_programme h2 {
  margin: 0;
}

.earn_programme {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 80%;
  margin-bottom: 10px;
}

.points_e_program {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 5px 0;
}

.points_e_program span {
  margin: 2px 0;
  background-color: #264740;
  color: #fff;
  padding: 5px;
  width: 70px;
  border-radius: 5px;
}

.label_e_program {
  color: #264740;
  font-weight: 600;
}

.gain_earn {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  font-size: large;
}

.gain_consom {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px 0 20px 0;
}

.gain_consom .gain {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f05d2e;
  color: #fff;
  border-radius: 20px;
  padding: 10px;
  margin: 0 10px;
  user-select: none;
  width: 200px;
}

.eaarn {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px;
  font-size: large;
}

.hiden_audio {
  /* width: 0.5px;
  height: 0.5px; */
  /* opacity: 0; */
  /* overflow: hidden; */
  display: block;
}

.payment_icon {
  width: 30px;
}

.paypal_payment_icon {
  width: 87px !important;
  object-fit: contain !important;
  position: relative;
  top: 22px;
}

.paymement_button {
  border-radius: 5px !important;
  background: #fff !important;
  color: #264740 !important;
  display: flex;
  justify-content: space-between;
}

.paymement_button img {
  width: 32px;
  height: 32px;
  object-fit: cover;
}

.paymement_button.card {
  background-color: #0b6eaf;
}

.paymement_button.cash {
  background-color: #a9d696;
}

.hidden {
  height: 0px;
  width: 0px;
  overflow: hidden;
}

.paypal_button {
  background-color: #ffc439 !important;
  padding: 0px !important;
  position: relative;
  height: 80px;
}

.client_form_conainer {
  padding: 12px;
}

.bonjour {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 20px;
}

.modal_title {
  display: block;
  padding: 16px 12px;
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  /* letter-spacing: 1.5px; */
  background: #1baaae;
  background: black;
  /* color: #37474f; */
  width: 100%;
  text-align: center;
}

.remove {
  color: #ff8080;
}

.infos_td {
  text-align: left;
}

.full {
  width: 100%;
  flex: 1;
  margin-bottom: 80px;
}

.full.center {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-bottom: 0px !important;
  margin-bottom: 0px !important;
  width: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  height: 100%;
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.modal_content {
  user-select: none;
  width: 100%;
  /* height: 100svh; */
  flex: 1;
  max-height: 100vh;
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  padding: 0px;
  padding-top: 0px;
}

.close_modal {
  position: absolute;
  top: 6px;
  right: 6px;
  padding: 12px;
  color: #37474f;
  color: #fff;
}

.vm--container {
  z-index: 999999;
}

.vm--modal {
  width: 100% !important;
  min-height: 100svh;
  top: 0px !important;
  left: 0px !important;
}

.bottom_commande {
  position: fixed;
  bottom: 0px;
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  left: 0px;
  /* display: none; */
}

.bottom_content {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 24px;
  background: transparent !important;
}

.bottom_content_box {
  background: #264740;
  /* width: 90%; */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 24px;
  border-radius: 50px;
  position: relative;
  bottom: 6px;
  flex: 1;
  text-align: right !important;
}

.count_articles {
  flex: 2;
  min-width: 75%;
  text-align: left;
}

.bottom_content span {
  color: #fff;
  font-size: 16px;
  font-weight: 600;
}

.bottom_content i {
  color: #fff;
}

.table-image thead td,
.table-image thead th {
  border: 0;
  color: #666;
  font-size: 0.8rem;
}

.table-image thead td,
.table-image thead th {
  vertical-align: middle;
  text-align: center;
}

.qty {
  max-width: 2rem;
}

.price {
  margin-left: 1rem;
}

.modal-footer {
  padding-top: 0rem;
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0;
  /* height: 100%; */
  width: 100%;
  max-width: 773px;
  left: 22px;
  border-radius: 0px;
}

.close {
  font-size: 22px;
}

@media screen and (max-width: 600px) {
  .google_fb {
    flex-direction: row;
    position: absolute;
    top: 480px;
  }

  .google_login {
    width: 30px;
    opacity: 0;
    margin-left: -80px;
  }

  .fb_login {
    width: 20px;
    opacity: 0;
    margin-left: 20px;
  }
}

@media (min-width: 576px) {
  .vm--container {
    max-width: 100%;
    margin-left: 0;
  }
}

@media (min-width: 768px) {
  .vm--container {
    max-width: 720px;
    margin-left: calc((100% - 720px) / 2);
  }
}

@media (min-width: 992px) {
  .vm--container {
    max-width: 960px;
    margin-left: calc((100% - 960px) / 2);
  }
}

@media (min-width: 1200px) {
  .vm--container {
    max-width: 1140px;
    margin-left: calc((100% - 1140px) / 2);
  }

  .container,
  .container-sm,
  .container-md,
  .container-lg,
  .container-xl {
    max-width: 1140px;
    padding: 0px !important;
  }
}

@media (min-width: 1400px) {
  .vm--container {
    max-width: 1320px;
    margin-left: calc((100% - 1320px) / 2);
  }
}

/* @media only screen and (min-width: 1000px) {


.vm--container{
      max-width: 780px;
    margin-left: calc((100% - 780px)/2);
}

} */
@media only screen and (max-width: 500px) {
  .addTo {
    top: 50px;
  }

  .ajouter {
    right: 50px !important;
    top: -16px !important;
    font-size: 10px !important;
  }

  .price {
    font-size: 12px;
    margin-left: 16px;
    font-weight: 500;
    min-width: unset;
    display: block;
    position: relative;
    right: 0px !important;
    text-align: right;
  }
}

@media only screen and (max-width: 800px) {
  .category_title {
    position: relative;
    width: calc(100% - 20px);
    font-size: 18px;
    font-weight: bold;
    text-transform: uppercase;
    border-bottom: 6px solid black;
    margin-bottom: 24px;
    display: block;
    padding-bottom: 12px;
  }

  .price {
    left: 12px;
  }

  .addTo {
    top: 49px !important;
    right: 11px !important;
    font-size: 12px !important;
  }

  /* .item {
    display: flex;
    width: calc(100% - 26px) !important;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 24px;
    border-bottom: 1px solid #8080801c;
    padding-bottom: 12px;

    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
} */

  .ajouter {
    font-size: 10px !important;
    right: 160px;
    top: 1px;
  }

  .price {
    font-size: 12px;
    margin-left: 16px;
    font-weight: 500;
    /* min-width: 80px; */
    display: block;
    position: relative;
    right: 0px !important;
    text-align: right;
  }

  .header,
  .body,
  .footer {
    width: 100%;
  }

  .subcategory_title {
    width: calc(100% - 0px) !important;
    right: 0px;
  }

  .category_title {
    width: calc(100% - 0px) !important;
    color: #fff;
    background: black;
    font-size: 16px !important;
    padding: 6px 12px !important;
  }

  .azour_body .category {
    padding-left: 12px !important;
    padding-right: 12px !important;
  }

  .azour_body .collapsed {
    right: 12px !important;
  }

  .modal-content {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    pointer-events: auto;
    background-color: #fff;
    background-clip: padding-box;
    border: unset;
    border-radius: 0.3rem;
    outline: 0;
    /* height: 100%; */
    width: 100%;
    max-width: 756px;
    left: 0px;
    border-radius: 0px;
    min-height: 100%;
  }

  .modal {
    left: 0px;
    top: 0px;
    padding: 0px !important;
    height: 100%;
  }

  .modal.show .modal-dialog {
    width: 100%;
    margin: 0px;
    height: 100%;
  }

  .modal-title {
    font-size: 14px;
    text-transform: uppercase;
  }

  td {
    font-size: 12px;
    font-weight: normal;
  }

  th {
    font-size: 12px;
    font-weight: bold;
  }

  .text-left {
    text-align: left !important;
  }
}

.quantity {
  display: flex;
  justify-content: center;
  align-items: center;
}

.controls_container {
  vertical-align: middle !important;
}

span.quantity_value {
  font-size: 14px;
  margin: 0px 9px;
  color: #000;
  flex: 1;
}

span.plus {
  background: #1baaae !important;
}

span.plus,
span.minus {
  background: #1baaae;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px;
  border-radius: 50%;
  vertical-align: middle;
  font-size: 7px;
  opacity: 0.9;
}

span.plus,
span.minus {
  background: #1baaae;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 3px;
  border-radius: 0px;
  vertical-align: middle;
  font-size: 7px;
  opacity: 0.9;
}

td {
  vertical-align: middle;
}

.remove {
  font-size: 18px !important;
  padding-right: 0px !important;
  text-align: right !important;
  width: 25px !important;
}

.bottom_commande_cart_half {
  flex-direction: column;
  justify-content: center;
  padding: 14px !important;
  align-items: center;
  position: fixed;
  bottom: 0px;
  width: 100%;
  padding-bottom: 24px;
}

.bottom_commande_cart {
  flex-direction: column;
  justify-content: center;
  padding: 14px !important;
  align-items: center;
  position: fixed;
  bottom: 0px;
  width: 100%;
  left: 0px;
  padding-bottom: 24px;
}

.modal_buttons {
  flex-direction: row;
  justify-content: space-between;
  padding: 14px !important;
  align-items: center;
  position: relative;
  /* position: absolute; */
  bottom: 0px;
  width: 100%;
  background: transparent !important;
}

#button_commander {
  width: 100%;
  background: #f05d2e;
  color: #fff;
  padding: 6px;
  text-align: center;
  display: flex;
  justify-content: space-between;
  margin: 0px;
  margin-bottom: 12px;
  border-radius: 50px;
}

.button_commander_half {
  width: 100%;
  background: #f05d2e;
  color: #fff;
  padding: 6px;
  text-align: center;
  display: flex;
  justify-content: space-between;
  margin: 0px;
  margin-bottom: 12px !important;
  border-radius: 10px;
}

.button_commander {
  padding: 6px 12px;
  flex: 1;
  justify-content: flex-start;
  text-align: left;
}

.total {
  padding: 6px 12px;
}

.showAllBill {
  padding: 6px 12px;
  flex: 1;
  justify-content: center;
  text-align: center;
  width: calc(100% - 24px);
  background: #f05d2e;
}

#showAllBill {
  width: calc(100% - 24px);
  background: #f05d2e;
  background: #f05d2e;
  color: #fff;
  padding: 6px;
  text-align: center;
  display: flex;
  justify-content: center;
  margin: auto;
  margin-bottom: 12px;
  border-radius: 50px;
  overflow: hidden;
}

#showAllBill1 .showAllBill {
  color: #f05d2e !important;
  text-decoration: underline !important;
  padding: 0px !important;
  background: transparent !important;
}

#showAllBill1 {
  width: calc(100% - 24px);
  background: transparent;
  color: #fff;
  padding: 6px;
  text-align: center;
  display: flex;
  justify-content: center;
  margin: auto;
  margin-bottom: 12px;
  border-radius: 50px;
  overflow: hidden;
}

.modal-header {
  background: #f05d2e;
  color: white;
  border-radius: 0px;
}

/* .modal.fade:not(.in).right .modal-dialog {
    -webkit-transform: translate3d(25%, 0, 0);
    transform: translate3d(25%, 0, 0);
} */

#payemnt_back {
  width: 100%;
  background: #f05d2e;
  color: #fff;
  /* padding: 12px; */
  text-align: center;
  display: flex;
  justify-content: flex-start;
  margin: 0px;
  align-items: center;
  padding-left: 20px;
  font-size: 12px;
}

.modal_button {
  flex: 1;
  width: auto;
  background: #f05d2e;
  color: #fff;
  /* padding: 12px; */
  text-align: center;
  display: flex;
  justify-content: center;
  margin: 0px 6px;
  align-items: center;
  padding: 12px;
  font-size: 12px;
  margin-top: 12px;
}

.modal_buttons {
  display: flex;
}

.paymement_buttons {
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  padding: 12px;
  padding-bottom: 150px;
}

.google_pay {
  padding: 16px !important;
}

.paymement_button {
  width: 100%;
  color: #fff;
  padding: 22px;
  margin: 6px 0px;
  flex-direction: row;
  display: flex;
  align-items: center;
  /* margin: 0px 6px; */
  font-size: 12px;
}

.modal_button_text {
}

.client-form {
  margin-bottom: 18px;
  font-size: 12px;
  text-align: left;
}

.client-form label {
  margin-bottom: 3px;
}

input {
  font-size: 12px !important;
}

.center_content {
  justify-content: center;
  align-items: center;
  display: flex;
}

.success_message img {
  width: 60%;
  margin-bottom: 20px;
}

.error_img {
  width: 80% !important;
  margin-bottom: 20px !important;
  position: relative;
  bottom: 40px;
}

@media only screen and (min-width: 1000px) {
  .error_img {
    width: 60% !important;
    margin-bottom: 20px !important;
    position: relative;
    bottom: 40px;
  }

  .success_message img {
    width: 30%;
    margin-bottom: 20px;
  }
}

.loading_img {
  width: 120px !important;
  margin-bottom: 20px !important;
  position: relative;
  bottom: 40px;
}

.expire_img {
  width: 180px !important;
  margin-bottom: 20px !important;
  position: relative;
  bottom: 40px;
}

.success_message {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  height: 100%;
  text-align: center;
  font-size: 14px;
  padding-bottom: 60px;
}

.pending_message {
  position: relative;
  bottom: 40px;
}

.form-control:focus {
  color: #212529;
  background-color: #fff;
  border-color: unset;
  outline: 0;
  box-shadow: unset;
}

.form-control {
  border-radius: 0px;
}

.loader {
  display: none;
  width: 100%;
  height: 100%;
}

.loader .loader_container {
  display: flex;
  width: 100%;
  height: 100%;
  padding-top: 50%;
  justify-content: center;
  align-items: center;
}

.lds-ripple {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

.lds-ripple div {
  position: absolute;
  border: 4px solid #000;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}

.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}

@keyframes lds-ripple {
  0% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 1;
  }

  100% {
    top: 0px;
    left: 0px;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
}

/* Variables */
* {
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 16px;
  -webkit-font-smoothing: antialiased;
  display: flex;
  justify-content: center;
  align-content: center;
  height: 100vh;
  width: 100vw;
}

/* form {
  width: 30vw;
  min-width: 500px;
  align-self: center;
  box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1),
    0px 2px 5px 0px rgba(50, 50, 93, 0.1), 0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);
  border-radius: 7px;
  padding: 40px;
} */

input {
  border-radius: 6px;
  margin-bottom: 6px;
  padding: 12px;
  border: 1px solid rgba(50, 50, 93, 0.1);
  height: 44px;
  font-size: 16px;
  width: 100%;
  background: white;
}

.result-message {
  line-height: 22px;
  font-size: 16px;
}

.result-message a {
  color: rgb(89, 111, 214);
  font-weight: 600;
  text-decoration: none;
}

.hidden {
  display: none;
}

#card-error {
  color: rgb(105, 115, 134);
  text-align: left;
  font-size: 13px;
  line-height: 17px;
  margin-top: 12px;
}

#card-element {
  border-radius: 4px 4px 0 0;
  padding: 12px;
  border: 1px solid rgba(50, 50, 93, 0.1);
  height: 44px;
  width: 100%;
  background: white;
}

#payment-request-button {
  margin-bottom: 32px;
}

/* Buttons and links */
button {
  background: #5469d4;
  color: #ffffff;
  font-family: Arial, sans-serif;
  border-radius: 0 0 4px 4px;
  border: 0;
  padding: 12px 16px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: block;
  transition: all 0.2s ease;
  box-shadow: 0px 4px 5.5px 0px rgba(0, 0, 0, 0.07);
  width: 100%;
}

button:hover {
  filter: contrast(115%);
}

button:disabled {
  opacity: 0.5;
  cursor: default;
}

/* spinner/processing state, errors */
.spinner,
.spinner:before,
.spinner:after {
  border-radius: 50%;
}

.spinner {
  color: #ffffff;
  font-size: 22px;
  text-indent: -99999px;
  margin: 0px auto;
  position: relative;
  width: 20px;
  height: 20px;
  box-shadow: inset 0 0 0 2px;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}

.spinner:before,
.spinner:after {
  position: absolute;
  content: "";
}

.spinner:before {
  width: 10.4px;
  height: 20.4px;
  background: #5469d4;
  border-radius: 20.4px 0 0 20.4px;
  top: -0.2px;
  left: -0.2px;
  -webkit-transform-origin: 10.4px 10.2px;
  transform-origin: 10.4px 10.2px;
  -webkit-animation: loading 2s infinite ease 1.5s;
  animation: loading 2s infinite ease 1.5s;
}

.spinner:after {
  width: 10.4px;
  height: 10.2px;
  background: #5469d4;
  border-radius: 0 10.2px 10.2px 0;
  top: -0.1px;
  left: 10.2px;
  -webkit-transform-origin: 0px 10.2px;
  transform-origin: 0px 10.2px;
  -webkit-animation: loading 2s infinite ease;
  animation: loading 2s infinite ease;
}

@-webkit-keyframes loading {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loading {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@media only screen and (max-width: 600px) {
  /* form {
    width: 80vw;
  } */
}

/* .card_monetico {
  border-radius: 5px;
  background: linear-gradient(68deg, #f28e09eb, #4c3040c9) !important;
}

.bitcoin_card {
  border-radius: 5px;
  background: linear-gradient(68deg, #f28e09eb, #f28e09eb) !important;
} */

#payment_form {
  width: 0.5px;
  height: 0.5px;
  opacity: 0;
  visibility: hidden;
}

@media only screen and (min-width: 800px) {
  /* .vm--modal {
    width: 88% !important;
    min-height: 100vh;
    top: 0px !important;
    left: 6% !important;
  } */
  span.plus,
  span.minus {
    background: black;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 0px;
    border-radius: 0px;
    vertical-align: middle;
    font-size: 7px;
    opacity: 0.9;
    border-radius: 3px;
  }
}

.modal-footer {
  background: #fff;
}

.modal_content {
  overflow: overlay;
}

form#payment-form {
  margin-top: 12px;
  /* padding: 16px 56px; */
}

.modal_down::after {
  content: " ";
  display: block;
  width: 35px;
  height: 35px;
  background: transparent;
  position: absolute;
  top: 12px;
  right: 12px;
  background-image: url("htttp://localhost:3333/new_images/close.png");
  background-size: contain;
  background-position: center;
  cursor: pointer;
  z-index: 99;
}

.orange_text {
  color: #f05d2e;
}

input.pin_input {
  margin-top: 12px;
}

.pin_input {
  width: 70% !important;
  border-radius: 50px !important;
  margin: auto;
  text-align: center !important;
}

.pin_box {
  width: 100%;
  padding-top: 12px !important;
}

.error_pin {
  text-align: center;
  color: #f05d2e !important;
  font-size: 12px !important;
}

.ask_buttons {
  display: flex;
  gap: 24px;
  margin-top: 24px;
}

.ask_button {
  width: 120px;
  height: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f05d2e;
  color: #fff;
  border-radius: 20px;
  font-size: 14px;
  user-select: none;
  /* transition: all .1s ease; */
}

.ask_button1:active {
  opacity: 0.2;
}

.ask_button:active {
  opacity: 0.2;
}

.ask_button1 {
  width: 120px;
  height: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #264740;
  color: #fff;
  border-radius: 20px;
  font-size: 14px;
  user-select: none;
  /* transition: all .1s ease; */
}

.join_name {
  width: 80%;
  border: 1px solid #607d8b;
  border-radius: 22px;
  margin-top: 12px;
}
</style>
